import { defineComponent as C0, openBlock as E0, createElementBlock as F0, normalizeClass as A0, unref as y0 } from "vue";
const Bu = {};
function w0(u) {
  let e = Bu[u];
  if (e)
    return e;
  e = Bu[u] = [];
  for (let r = 0; r < 128; r++) {
    const c = String.fromCharCode(r);
    e.push(c);
  }
  for (let r = 0; r < u.length; r++) {
    const c = u.charCodeAt(r);
    e[c] = "%" + ("0" + c.toString(16).toUpperCase()).slice(-2);
  }
  return e;
}
function Z(u, e) {
  typeof e != "string" && (e = Z.defaultChars);
  const r = w0(e);
  return u.replace(/(%[a-f0-9]{2})+/gi, function(c) {
    let n = "";
    for (let t = 0, o = c.length; t < o; t += 3) {
      const i = parseInt(c.slice(t + 1, t + 3), 16);
      if (i < 128) {
        n += r[i];
        continue;
      }
      if ((i & 224) === 192 && t + 3 < o) {
        const a = parseInt(c.slice(t + 4, t + 6), 16);
        if ((a & 192) === 128) {
          const s = i << 6 & 1984 | a & 63;
          s < 128 ? n += "��" : n += String.fromCharCode(s), t += 3;
          continue;
        }
      }
      if ((i & 240) === 224 && t + 6 < o) {
        const a = parseInt(c.slice(t + 4, t + 6), 16), s = parseInt(c.slice(t + 7, t + 9), 16);
        if ((a & 192) === 128 && (s & 192) === 128) {
          const f = i << 12 & 61440 | a << 6 & 4032 | s & 63;
          f < 2048 || f >= 55296 && f <= 57343 ? n += "���" : n += String.fromCharCode(f), t += 6;
          continue;
        }
      }
      if ((i & 248) === 240 && t + 9 < o) {
        const a = parseInt(c.slice(t + 4, t + 6), 16), s = parseInt(c.slice(t + 7, t + 9), 16), f = parseInt(c.slice(t + 10, t + 12), 16);
        if ((a & 192) === 128 && (s & 192) === 128 && (f & 192) === 128) {
          let d = i << 18 & 1835008 | a << 12 & 258048 | s << 6 & 4032 | f & 63;
          d < 65536 || d > 1114111 ? n += "����" : (d -= 65536, n += String.fromCharCode(55296 + (d >> 10), 56320 + (d & 1023))), t += 9;
          continue;
        }
      }
      n += "�";
    }
    return n;
  });
}
Z.defaultChars = ";/?:@&=+$,#";
Z.componentChars = "";
const Tu = {};
function S0(u) {
  let e = Tu[u];
  if (e)
    return e;
  e = Tu[u] = [];
  for (let r = 0; r < 128; r++) {
    const c = String.fromCharCode(r);
    /^[0-9a-z]$/i.test(c) ? e.push(c) : e.push("%" + ("0" + r.toString(16).toUpperCase()).slice(-2));
  }
  for (let r = 0; r < u.length; r++)
    e[u.charCodeAt(r)] = u[r];
  return e;
}
function Y(u, e, r) {
  typeof e != "string" && (r = e, e = Y.defaultChars), typeof r > "u" && (r = !0);
  const c = S0(e);
  let n = "";
  for (let t = 0, o = u.length; t < o; t++) {
    const i = u.charCodeAt(t);
    if (r && i === 37 && t + 2 < o && /^[0-9a-f]{2}$/i.test(u.slice(t + 1, t + 3))) {
      n += u.slice(t, t + 3), t += 2;
      continue;
    }
    if (i < 128) {
      n += c[i];
      continue;
    }
    if (i >= 55296 && i <= 57343) {
      if (i >= 55296 && i <= 56319 && t + 1 < o) {
        const a = u.charCodeAt(t + 1);
        if (a >= 56320 && a <= 57343) {
          n += encodeURIComponent(u[t] + u[t + 1]), t++;
          continue;
        }
      }
      n += "%EF%BF%BD";
      continue;
    }
    n += encodeURIComponent(u[t]);
  }
  return n;
}
Y.defaultChars = ";/?:@&=+$,-_.!~*'()#";
Y.componentChars = "-_.!~*'()";
function Du(u) {
  let e = "";
  return e += u.protocol || "", e += u.slashes ? "//" : "", e += u.auth ? u.auth + "@" : "", u.hostname && u.hostname.indexOf(":") !== -1 ? e += "[" + u.hostname + "]" : e += u.hostname || "", e += u.port ? ":" + u.port : "", e += u.pathname || "", e += u.search || "", e += u.hash || "", e;
}
function nu() {
  this.protocol = null, this.slashes = null, this.auth = null, this.port = null, this.hostname = null, this.hash = null, this.search = null, this.pathname = null;
}
const v0 = /^([a-z0-9.+-]+:)/i, B0 = /:[0-9]*$/, T0 = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, z0 = ["<", ">", '"', "`", " ", "\r", `
`, "	"], I0 = ["{", "}", "|", "\\", "^", "`"].concat(z0), M0 = ["'"].concat(I0), zu = ["%", "/", "?", ";", "#"].concat(M0), Iu = ["/", "?", "#"], q0 = 255, Mu = /^[+a-z0-9A-Z_-]{0,63}$/, R0 = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, qu = {
  javascript: !0,
  "javascript:": !0
}, Ru = {
  http: !0,
  https: !0,
  ftp: !0,
  gopher: !0,
  file: !0,
  "http:": !0,
  "https:": !0,
  "ftp:": !0,
  "gopher:": !0,
  "file:": !0
};
function Cu(u, e) {
  if (u && u instanceof nu) return u;
  const r = new nu();
  return r.parse(u, e), r;
}
nu.prototype.parse = function(u, e) {
  let r, c, n, t = u;
  if (t = t.trim(), !e && u.split("#").length === 1) {
    const s = T0.exec(t);
    if (s)
      return this.pathname = s[1], s[2] && (this.search = s[2]), this;
  }
  let o = v0.exec(t);
  if (o && (o = o[0], r = o.toLowerCase(), this.protocol = o, t = t.substr(o.length)), (e || o || t.match(/^\/\/[^@\/]+@[^@\/]+/)) && (n = t.substr(0, 2) === "//", n && !(o && qu[o]) && (t = t.substr(2), this.slashes = !0)), !qu[o] && (n || o && !Ru[o])) {
    let s = -1;
    for (let l = 0; l < Iu.length; l++)
      c = t.indexOf(Iu[l]), c !== -1 && (s === -1 || c < s) && (s = c);
    let f, d;
    s === -1 ? d = t.lastIndexOf("@") : d = t.lastIndexOf("@", s), d !== -1 && (f = t.slice(0, d), t = t.slice(d + 1), this.auth = f), s = -1;
    for (let l = 0; l < zu.length; l++)
      c = t.indexOf(zu[l]), c !== -1 && (s === -1 || c < s) && (s = c);
    s === -1 && (s = t.length), t[s - 1] === ":" && s--;
    const b = t.slice(0, s);
    t = t.slice(s), this.parseHost(b), this.hostname = this.hostname || "";
    const h = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
    if (!h) {
      const l = this.hostname.split(/\./);
      for (let k = 0, g = l.length; k < g; k++) {
        const C = l[k];
        if (C && !C.match(Mu)) {
          let p = "";
          for (let _ = 0, x = C.length; _ < x; _++)
            C.charCodeAt(_) > 127 ? p += "x" : p += C[_];
          if (!p.match(Mu)) {
            const _ = l.slice(0, k), x = l.slice(k + 1), m = C.match(R0);
            m && (_.push(m[1]), x.unshift(m[2])), x.length && (t = x.join(".") + t), this.hostname = _.join(".");
            break;
          }
        }
      }
    }
    this.hostname.length > q0 && (this.hostname = ""), h && (this.hostname = this.hostname.substr(1, this.hostname.length - 2));
  }
  const i = t.indexOf("#");
  i !== -1 && (this.hash = t.substr(i), t = t.slice(0, i));
  const a = t.indexOf("?");
  return a !== -1 && (this.search = t.substr(a), t = t.slice(0, a)), t && (this.pathname = t), Ru[r] && this.hostname && !this.pathname && (this.pathname = ""), this;
};
nu.prototype.parseHost = function(u) {
  let e = B0.exec(u);
  e && (e = e[0], e !== ":" && (this.port = e.substr(1)), u = u.substr(0, u.length - e.length)), u && (this.hostname = u);
};
const L0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  decode: Z,
  encode: Y,
  format: Du,
  parse: Cu
}, Symbol.toStringTag, { value: "Module" })), Wu = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/, Ju = /[\0-\x1F\x7F-\x9F]/, P0 = /[\xAD\u0600-\u0605\u061C\u06DD\u070F\u0890\u0891\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804[\uDCBD\uDCCD]|\uD80D[\uDC30-\uDC3F]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/, Eu = /[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDEAD\uDF55-\uDF59\uDF86-\uDF89]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5A\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDEB9\uDF3C-\uDF3E]|\uD806[\uDC3B\uDD44-\uDD46\uDDE2\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2\uDF00-\uDF09]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8\uDF43-\uDF4F\uDFFF]|\uD809[\uDC70-\uDC74]|\uD80B[\uDFF1\uDFF2]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A\uDFE2]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/, Qu = /[\$\+<->\^`\|~\xA2-\xA6\xA8\xA9\xAC\xAE-\xB1\xB4\xB8\xD7\xF7\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u0384\u0385\u03F6\u0482\u058D-\u058F\u0606-\u0608\u060B\u060E\u060F\u06DE\u06E9\u06FD\u06FE\u07F6\u07FE\u07FF\u0888\u09F2\u09F3\u09FA\u09FB\u0AF1\u0B70\u0BF3-\u0BFA\u0C7F\u0D4F\u0D79\u0E3F\u0F01-\u0F03\u0F13\u0F15-\u0F17\u0F1A-\u0F1F\u0F34\u0F36\u0F38\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE\u0FCF\u0FD5-\u0FD8\u109E\u109F\u1390-\u1399\u166D\u17DB\u1940\u19DE-\u19FF\u1B61-\u1B6A\u1B74-\u1B7C\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u2044\u2052\u207A-\u207C\u208A-\u208C\u20A0-\u20C0\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F\u218A\u218B\u2190-\u2307\u230C-\u2328\u232B-\u2426\u2440-\u244A\u249C-\u24E9\u2500-\u2767\u2794-\u27C4\u27C7-\u27E5\u27F0-\u2982\u2999-\u29D7\u29DC-\u29FB\u29FE-\u2B73\u2B76-\u2B95\u2B97-\u2BFF\u2CE5-\u2CEA\u2E50\u2E51\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFF\u3004\u3012\u3013\u3020\u3036\u3037\u303E\u303F\u309B\u309C\u3190\u3191\u3196-\u319F\u31C0-\u31E3\u31EF\u3200-\u321E\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u33FF\u4DC0-\u4DFF\uA490-\uA4C6\uA700-\uA716\uA720\uA721\uA789\uA78A\uA828-\uA82B\uA836-\uA839\uAA77-\uAA79\uAB5B\uAB6A\uAB6B\uFB29\uFBB2-\uFBC2\uFD40-\uFD4F\uFDCF\uFDFC-\uFDFF\uFE62\uFE64-\uFE66\uFE69\uFF04\uFF0B\uFF1C-\uFF1E\uFF3E\uFF40\uFF5C\uFF5E\uFFE0-\uFFE6\uFFE8-\uFFEE\uFFFC\uFFFD]|\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9C\uDDA0\uDDD0-\uDDFC]|\uD802[\uDC77\uDC78\uDEC8]|\uD805\uDF3F|\uD807[\uDFD5-\uDFF1]|\uD81A[\uDF3C-\uDF3F\uDF45]|\uD82F\uDC9C|\uD833[\uDF50-\uDFC3]|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDEA\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|\uD838[\uDD4F\uDEFF]|\uD83B[\uDCAC\uDCB0\uDD2E\uDEF0\uDEF1]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD0D-\uDDAD\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFF]|\uD83D[\uDC00-\uDED7\uDEDC-\uDEEC\uDEF0-\uDEFC\uDF00-\uDF76\uDF7B-\uDFD9\uDFE0-\uDFEB\uDFF0]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDCB0\uDCB1\uDD00-\uDE53\uDE60-\uDE6D\uDE70-\uDE7C\uDE80-\uDE88\uDE90-\uDEBD\uDEBF-\uDEC5\uDECE-\uDEDB\uDEE0-\uDEE8\uDEF0-\uDEF8\uDF00-\uDF92\uDF94-\uDFCA]/, Xu = /[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/, O0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Any: Wu,
  Cc: Ju,
  Cf: P0,
  P: Eu,
  S: Qu,
  Z: Xu
}, Symbol.toStringTag, { value: "Module" })), N0 = new Uint16Array(
  // prettier-ignore
  'ᵁ<Õıʊҝջאٵ۞ޢߖࠏ੊ઑඡ๭༉༦჊ረዡᐕᒝᓃᓟᔥ\0\0\0\0\0\0ᕫᛍᦍᰒᷝ὾⁠↰⊍⏀⏻⑂⠤⤒ⴈ⹈⿎〖㊺㘹㞬㣾㨨㩱㫠㬮ࠀEMabcfglmnoprstu\\bfms¦³¹ÈÏlig耻Æ䃆P耻&䀦cute耻Á䃁reve;䄂Āiyx}rc耻Â䃂;䐐r;쀀𝔄rave耻À䃀pha;䎑acr;䄀d;橓Āgp¡on;䄄f;쀀𝔸plyFunction;恡ing耻Å䃅Ācs¾Ãr;쀀𝒜ign;扔ilde耻Ã䃃ml耻Ä䃄ЀaceforsuåûþėĜĢħĪĀcrêòkslash;或Ŷöø;櫧ed;挆y;䐑ƀcrtąċĔause;戵noullis;愬a;䎒r;쀀𝔅pf;쀀𝔹eve;䋘còēmpeq;扎܀HOacdefhilorsuōőŖƀƞƢƵƷƺǜȕɳɸɾcy;䐧PY耻©䂩ƀcpyŝŢźute;䄆Ā;iŧŨ拒talDifferentialD;慅leys;愭ȀaeioƉƎƔƘron;䄌dil耻Ç䃇rc;䄈nint;戰ot;䄊ĀdnƧƭilla;䂸terDot;䂷òſi;䎧rcleȀDMPTǇǋǑǖot;抙inus;抖lus;投imes;抗oĀcsǢǸkwiseContourIntegral;戲eCurlyĀDQȃȏoubleQuote;思uote;怙ȀlnpuȞȨɇɕonĀ;eȥȦ户;橴ƀgitȯȶȺruent;扡nt;戯ourIntegral;戮ĀfrɌɎ;愂oduct;成nterClockwiseContourIntegral;戳oss;樯cr;쀀𝒞pĀ;Cʄʅ拓ap;才րDJSZacefiosʠʬʰʴʸˋ˗ˡ˦̳ҍĀ;oŹʥtrahd;椑cy;䐂cy;䐅cy;䐏ƀgrsʿ˄ˇger;怡r;憡hv;櫤Āayː˕ron;䄎;䐔lĀ;t˝˞戇a;䎔r;쀀𝔇Āaf˫̧Ācm˰̢riticalȀADGT̖̜̀̆cute;䂴oŴ̋̍;䋙bleAcute;䋝rave;䁠ilde;䋜ond;拄ferentialD;慆Ѱ̽\0\0\0͔͂\0Ѕf;쀀𝔻ƀ;DE͈͉͍䂨ot;惜qual;扐blèCDLRUVͣͲ΂ϏϢϸontourIntegraìȹoɴ͹\0\0ͻ»͉nArrow;懓Āeo·ΤftƀARTΐΖΡrrow;懐ightArrow;懔eåˊngĀLRΫτeftĀARγιrrow;柸ightArrow;柺ightArrow;柹ightĀATϘϞrrow;懒ee;抨pɁϩ\0\0ϯrrow;懑ownArrow;懕erticalBar;戥ǹABLRTaВЪаўѿͼrrowƀ;BUНОТ憓ar;椓pArrow;懵reve;䌑eft˒к\0ц\0ѐightVector;楐eeVector;楞ectorĀ;Bљњ憽ar;楖ightǔѧ\0ѱeeVector;楟ectorĀ;BѺѻ懁ar;楗eeĀ;A҆҇护rrow;憧ĀctҒҗr;쀀𝒟rok;䄐ࠀNTacdfglmopqstuxҽӀӄӋӞӢӧӮӵԡԯԶՒ՝ՠեG;䅊H耻Ð䃐cute耻É䃉ƀaiyӒӗӜron;䄚rc耻Ê䃊;䐭ot;䄖r;쀀𝔈rave耻È䃈ement;戈ĀapӺӾcr;䄒tyɓԆ\0\0ԒmallSquare;旻erySmallSquare;斫ĀgpԦԪon;䄘f;쀀𝔼silon;䎕uĀaiԼՉlĀ;TՂՃ橵ilde;扂librium;懌Āci՗՚r;愰m;橳a;䎗ml耻Ë䃋Āipժկsts;戃onentialE;慇ʀcfiosօֈ֍ֲ׌y;䐤r;쀀𝔉lledɓ֗\0\0֣mallSquare;旼erySmallSquare;斪Ͱֺ\0ֿ\0\0ׄf;쀀𝔽All;戀riertrf;愱cò׋؀JTabcdfgorstר׬ׯ׺؀ؒؖ؛؝أ٬ٲcy;䐃耻>䀾mmaĀ;d׷׸䎓;䏜reve;䄞ƀeiy؇،ؐdil;䄢rc;䄜;䐓ot;䄠r;쀀𝔊;拙pf;쀀𝔾eater̀EFGLSTصلَٖٛ٦qualĀ;Lؾؿ扥ess;招ullEqual;执reater;檢ess;扷lantEqual;橾ilde;扳cr;쀀𝒢;扫ЀAacfiosuڅڋږڛڞڪھۊRDcy;䐪Āctڐڔek;䋇;䁞irc;䄤r;愌lbertSpace;愋ǰگ\0ڲf;愍izontalLine;攀Āctۃۅòکrok;䄦mpńېۘownHumðįqual;扏܀EJOacdfgmnostuۺ۾܃܇܎ܚܞܡܨ݄ݸދޏޕcy;䐕lig;䄲cy;䐁cute耻Í䃍Āiyܓܘrc耻Î䃎;䐘ot;䄰r;愑rave耻Ì䃌ƀ;apܠܯܿĀcgܴܷr;䄪inaryI;慈lieóϝǴ݉\0ݢĀ;eݍݎ戬Āgrݓݘral;戫section;拂isibleĀCTݬݲomma;恣imes;恢ƀgptݿރވon;䄮f;쀀𝕀a;䎙cr;愐ilde;䄨ǫޚ\0ޞcy;䐆l耻Ï䃏ʀcfosuެ޷޼߂ߐĀiyޱ޵rc;䄴;䐙r;쀀𝔍pf;쀀𝕁ǣ߇\0ߌr;쀀𝒥rcy;䐈kcy;䐄΀HJacfosߤߨ߽߬߱ࠂࠈcy;䐥cy;䐌ppa;䎚Āey߶߻dil;䄶;䐚r;쀀𝔎pf;쀀𝕂cr;쀀𝒦րJTaceflmostࠥࠩࠬࡐࡣ঳সে্਷ੇcy;䐉耻<䀼ʀcmnpr࠷࠼ࡁࡄࡍute;䄹bda;䎛g;柪lacetrf;愒r;憞ƀaeyࡗ࡜ࡡron;䄽dil;䄻;䐛Āfsࡨ॰tԀACDFRTUVarࡾࢩࢱࣦ࣠ࣼयज़ΐ४Ānrࢃ࢏gleBracket;柨rowƀ;BR࢙࢚࢞憐ar;懤ightArrow;懆eiling;挈oǵࢷ\0ࣃbleBracket;柦nǔࣈ\0࣒eeVector;楡ectorĀ;Bࣛࣜ懃ar;楙loor;挊ightĀAV࣯ࣵrrow;憔ector;楎Āerँगeƀ;AVउऊऐ抣rrow;憤ector;楚iangleƀ;BEतथऩ抲ar;槏qual;抴pƀDTVषूौownVector;楑eeVector;楠ectorĀ;Bॖॗ憿ar;楘ectorĀ;B॥०憼ar;楒ightáΜs̀EFGLSTॾঋকঝঢভqualGreater;拚ullEqual;扦reater;扶ess;檡lantEqual;橽ilde;扲r;쀀𝔏Ā;eঽা拘ftarrow;懚idot;䄿ƀnpw৔ਖਛgȀLRlr৞৷ਂਐeftĀAR০৬rrow;柵ightArrow;柷ightArrow;柶eftĀarγਊightáοightáϊf;쀀𝕃erĀLRਢਬeftArrow;憙ightArrow;憘ƀchtਾੀੂòࡌ;憰rok;䅁;扪Ѐacefiosuਗ਼੝੠੷੼અઋ઎p;椅y;䐜Ādl੥੯iumSpace;恟lintrf;愳r;쀀𝔐nusPlus;戓pf;쀀𝕄cò੶;䎜ҀJacefostuણધભીଔଙඑ඗ඞcy;䐊cute;䅃ƀaey઴હાron;䅇dil;䅅;䐝ƀgswે૰଎ativeƀMTV૓૟૨ediumSpace;怋hiĀcn૦૘ë૙eryThiî૙tedĀGL૸ଆreaterGreateòٳessLesóੈLine;䀊r;쀀𝔑ȀBnptଢନଷ଺reak;恠BreakingSpace;䂠f;愕ڀ;CDEGHLNPRSTV୕ୖ୪୼஡௫ఄ౞಄ದ೘ൡඅ櫬Āou୛୤ngruent;扢pCap;扭oubleVerticalBar;戦ƀlqxஃஊ஛ement;戉ualĀ;Tஒஓ扠ilde;쀀≂̸ists;戄reater΀;EFGLSTஶஷ஽௉௓௘௥扯qual;扱ullEqual;쀀≧̸reater;쀀≫̸ess;批lantEqual;쀀⩾̸ilde;扵umpń௲௽ownHump;쀀≎̸qual;쀀≏̸eĀfsఊధtTriangleƀ;BEచఛడ拪ar;쀀⧏̸qual;括s̀;EGLSTవశ఼ౄోౘ扮qual;扰reater;扸ess;쀀≪̸lantEqual;쀀⩽̸ilde;扴estedĀGL౨౹reaterGreater;쀀⪢̸essLess;쀀⪡̸recedesƀ;ESಒಓಛ技qual;쀀⪯̸lantEqual;拠ĀeiಫಹverseElement;戌ghtTriangleƀ;BEೋೌ೒拫ar;쀀⧐̸qual;拭ĀquೝഌuareSuĀbp೨೹setĀ;E೰ೳ쀀⊏̸qual;拢ersetĀ;Eഃആ쀀⊐̸qual;拣ƀbcpഓതൎsetĀ;Eഛഞ쀀⊂⃒qual;抈ceedsȀ;ESTലള഻െ抁qual;쀀⪰̸lantEqual;拡ilde;쀀≿̸ersetĀ;E൘൛쀀⊃⃒qual;抉ildeȀ;EFT൮൯൵ൿ扁qual;扄ullEqual;扇ilde;扉erticalBar;戤cr;쀀𝒩ilde耻Ñ䃑;䎝܀Eacdfgmoprstuvලෂ෉෕ෛ෠෧෼ขภยา฿ไlig;䅒cute耻Ó䃓Āiy෎ීrc耻Ô䃔;䐞blac;䅐r;쀀𝔒rave耻Ò䃒ƀaei෮ෲ෶cr;䅌ga;䎩cron;䎟pf;쀀𝕆enCurlyĀDQฎบoubleQuote;怜uote;怘;橔Āclวฬr;쀀𝒪ash耻Ø䃘iŬื฼de耻Õ䃕es;樷ml耻Ö䃖erĀBP๋๠Āar๐๓r;怾acĀek๚๜;揞et;掴arenthesis;揜Ҁacfhilors๿ງຊຏຒດຝະ໼rtialD;戂y;䐟r;쀀𝔓i;䎦;䎠usMinus;䂱Āipຢອncareplanåڝf;愙Ȁ;eio຺ູ໠໤檻cedesȀ;EST່້໏໚扺qual;檯lantEqual;扼ilde;找me;怳Ādp໩໮uct;戏ortionĀ;aȥ໹l;戝Āci༁༆r;쀀𝒫;䎨ȀUfos༑༖༛༟OT耻"䀢r;쀀𝔔pf;愚cr;쀀𝒬؀BEacefhiorsu༾གྷཇའཱིྦྷྪྭ႖ႩႴႾarr;椐G耻®䂮ƀcnrཎནབute;䅔g;柫rĀ;tཛྷཝ憠l;椖ƀaeyཧཬཱron;䅘dil;䅖;䐠Ā;vླྀཹ愜erseĀEUྂྙĀlq྇ྎement;戋uilibrium;懋pEquilibrium;楯r»ཹo;䎡ghtЀACDFTUVa࿁࿫࿳ဢဨၛႇϘĀnr࿆࿒gleBracket;柩rowƀ;BL࿜࿝࿡憒ar;懥eftArrow;懄eiling;按oǵ࿹\0စbleBracket;柧nǔည\0နeeVector;楝ectorĀ;Bဝသ懂ar;楕loor;挋Āerိ၃eƀ;AVဵံြ抢rrow;憦ector;楛iangleƀ;BEၐၑၕ抳ar;槐qual;抵pƀDTVၣၮၸownVector;楏eeVector;楜ectorĀ;Bႂႃ憾ar;楔ectorĀ;B႑႒懀ar;楓Āpuႛ႞f;愝ndImplies;楰ightarrow;懛ĀchႹႼr;愛;憱leDelayed;槴ڀHOacfhimoqstuფჱჷჽᄙᄞᅑᅖᅡᅧᆵᆻᆿĀCcჩხHcy;䐩y;䐨FTcy;䐬cute;䅚ʀ;aeiyᄈᄉᄎᄓᄗ檼ron;䅠dil;䅞rc;䅜;䐡r;쀀𝔖ortȀDLRUᄪᄴᄾᅉownArrow»ОeftArrow»࢚ightArrow»࿝pArrow;憑gma;䎣allCircle;战pf;쀀𝕊ɲᅭ\0\0ᅰt;戚areȀ;ISUᅻᅼᆉᆯ斡ntersection;抓uĀbpᆏᆞsetĀ;Eᆗᆘ抏qual;抑ersetĀ;Eᆨᆩ抐qual;抒nion;抔cr;쀀𝒮ar;拆ȀbcmpᇈᇛሉላĀ;sᇍᇎ拐etĀ;Eᇍᇕqual;抆ĀchᇠህeedsȀ;ESTᇭᇮᇴᇿ扻qual;檰lantEqual;扽ilde;承Tháྌ;我ƀ;esሒሓሣ拑rsetĀ;Eሜም抃qual;抇et»ሓրHRSacfhiorsሾቄ቉ቕ቞ቱቶኟዂወዑORN耻Þ䃞ADE;愢ĀHc቎ቒcy;䐋y;䐦Ābuቚቜ;䀉;䎤ƀaeyብቪቯron;䅤dil;䅢;䐢r;쀀𝔗Āeiቻ኉ǲኀ\0ኇefore;戴a;䎘Ācn኎ኘkSpace;쀀  Space;怉ldeȀ;EFTካኬኲኼ戼qual;扃ullEqual;扅ilde;扈pf;쀀𝕋ipleDot;惛Āctዖዛr;쀀𝒯rok;䅦ૡዷጎጚጦ\0ጬጱ\0\0\0\0\0ጸጽ፷ᎅ\0᏿ᐄᐊᐐĀcrዻጁute耻Ú䃚rĀ;oጇገ憟cir;楉rǣጓ\0጖y;䐎ve;䅬Āiyጞጣrc耻Û䃛;䐣blac;䅰r;쀀𝔘rave耻Ù䃙acr;䅪Ādiፁ፩erĀBPፈ፝Āarፍፐr;䁟acĀekፗፙ;揟et;掵arenthesis;揝onĀ;P፰፱拃lus;抎Āgp፻፿on;䅲f;쀀𝕌ЀADETadps᎕ᎮᎸᏄϨᏒᏗᏳrrowƀ;BDᅐᎠᎤar;椒ownArrow;懅ownArrow;憕quilibrium;楮eeĀ;AᏋᏌ报rrow;憥ownáϳerĀLRᏞᏨeftArrow;憖ightArrow;憗iĀ;lᏹᏺ䏒on;䎥ing;䅮cr;쀀𝒰ilde;䅨ml耻Ü䃜ҀDbcdefosvᐧᐬᐰᐳᐾᒅᒊᒐᒖash;披ar;櫫y;䐒ashĀ;lᐻᐼ抩;櫦Āerᑃᑅ;拁ƀbtyᑌᑐᑺar;怖Ā;iᑏᑕcalȀBLSTᑡᑥᑪᑴar;戣ine;䁼eparator;杘ilde;所ThinSpace;怊r;쀀𝔙pf;쀀𝕍cr;쀀𝒱dash;抪ʀcefosᒧᒬᒱᒶᒼirc;䅴dge;拀r;쀀𝔚pf;쀀𝕎cr;쀀𝒲Ȁfiosᓋᓐᓒᓘr;쀀𝔛;䎞pf;쀀𝕏cr;쀀𝒳ҀAIUacfosuᓱᓵᓹᓽᔄᔏᔔᔚᔠcy;䐯cy;䐇cy;䐮cute耻Ý䃝Āiyᔉᔍrc;䅶;䐫r;쀀𝔜pf;쀀𝕐cr;쀀𝒴ml;䅸ЀHacdefosᔵᔹᔿᕋᕏᕝᕠᕤcy;䐖cute;䅹Āayᕄᕉron;䅽;䐗ot;䅻ǲᕔ\0ᕛoWidtè૙a;䎖r;愨pf;愤cr;쀀𝒵௡ᖃᖊᖐ\0ᖰᖶᖿ\0\0\0\0ᗆᗛᗫᙟ᙭\0ᚕ᚛ᚲᚹ\0ᚾcute耻á䃡reve;䄃̀;Ediuyᖜᖝᖡᖣᖨᖭ戾;쀀∾̳;房rc耻â䃢te肻´̆;䐰lig耻æ䃦Ā;r²ᖺ;쀀𝔞rave耻à䃠ĀepᗊᗖĀfpᗏᗔsym;愵èᗓha;䎱ĀapᗟcĀclᗤᗧr;䄁g;樿ɤᗰ\0\0ᘊʀ;adsvᗺᗻᗿᘁᘇ戧nd;橕;橜lope;橘;橚΀;elmrszᘘᘙᘛᘞᘿᙏᙙ戠;榤e»ᘙsdĀ;aᘥᘦ戡ѡᘰᘲᘴᘶᘸᘺᘼᘾ;榨;榩;榪;榫;榬;榭;榮;榯tĀ;vᙅᙆ戟bĀ;dᙌᙍ抾;榝Āptᙔᙗh;戢»¹arr;捼Āgpᙣᙧon;䄅f;쀀𝕒΀;Eaeiop዁ᙻᙽᚂᚄᚇᚊ;橰cir;橯;扊d;手s;䀧roxĀ;e዁ᚒñᚃing耻å䃥ƀctyᚡᚦᚨr;쀀𝒶;䀪mpĀ;e዁ᚯñʈilde耻ã䃣ml耻ä䃤Āciᛂᛈoninôɲnt;樑ࠀNabcdefiklnoprsu᛭ᛱᜰ᜼ᝃᝈ᝸᝽០៦ᠹᡐᜍ᤽᥈ᥰot;櫭Ācrᛶ᜞kȀcepsᜀᜅᜍᜓong;扌psilon;䏶rime;怵imĀ;e᜚᜛戽q;拍Ŷᜢᜦee;抽edĀ;gᜬᜭ挅e»ᜭrkĀ;t፜᜷brk;掶Āoyᜁᝁ;䐱quo;怞ʀcmprtᝓ᝛ᝡᝤᝨausĀ;eĊĉptyv;榰séᜌnoõēƀahwᝯ᝱ᝳ;䎲;愶een;扬r;쀀𝔟g΀costuvwឍឝឳេ៕៛៞ƀaiuបពរðݠrc;旯p»፱ƀdptឤឨឭot;樀lus;樁imes;樂ɱឹ\0\0ើcup;樆ar;昅riangleĀdu៍្own;施p;斳plus;樄eåᑄåᒭarow;植ƀako៭ᠦᠵĀcn៲ᠣkƀlst៺֫᠂ozenge;槫riangleȀ;dlr᠒᠓᠘᠝斴own;斾eft;旂ight;斸k;搣Ʊᠫ\0ᠳƲᠯ\0ᠱ;斒;斑4;斓ck;斈ĀeoᠾᡍĀ;qᡃᡆ쀀=⃥uiv;쀀≡⃥t;挐Ȁptwxᡙᡞᡧᡬf;쀀𝕓Ā;tᏋᡣom»Ꮜtie;拈؀DHUVbdhmptuvᢅᢖᢪᢻᣗᣛᣬ᣿ᤅᤊᤐᤡȀLRlrᢎᢐᢒᢔ;敗;敔;敖;敓ʀ;DUduᢡᢢᢤᢦᢨ敐;敦;敩;敤;敧ȀLRlrᢳᢵᢷᢹ;敝;敚;敜;教΀;HLRhlrᣊᣋᣍᣏᣑᣓᣕ救;敬;散;敠;敫;敢;敟ox;槉ȀLRlrᣤᣦᣨᣪ;敕;敒;攐;攌ʀ;DUduڽ᣷᣹᣻᣽;敥;敨;攬;攴inus;抟lus;択imes;抠ȀLRlrᤙᤛᤝ᤟;敛;敘;攘;攔΀;HLRhlrᤰᤱᤳᤵᤷ᤻᤹攂;敪;敡;敞;攼;攤;攜Āevģ᥂bar耻¦䂦Ȁceioᥑᥖᥚᥠr;쀀𝒷mi;恏mĀ;e᜚᜜lƀ;bhᥨᥩᥫ䁜;槅sub;柈Ŭᥴ᥾lĀ;e᥹᥺怢t»᥺pƀ;Eeįᦅᦇ;檮Ā;qۜۛೡᦧ\0᧨ᨑᨕᨲ\0ᨷᩐ\0\0᪴\0\0᫁\0\0ᬡᬮ᭍᭒\0᯽\0ᰌƀcpr᦭ᦲ᧝ute;䄇̀;abcdsᦿᧀᧄ᧊᧕᧙戩nd;橄rcup;橉Āau᧏᧒p;橋p;橇ot;橀;쀀∩︀Āeo᧢᧥t;恁îړȀaeiu᧰᧻ᨁᨅǰ᧵\0᧸s;橍on;䄍dil耻ç䃧rc;䄉psĀ;sᨌᨍ橌m;橐ot;䄋ƀdmnᨛᨠᨦil肻¸ƭptyv;榲t脀¢;eᨭᨮ䂢räƲr;쀀𝔠ƀceiᨽᩀᩍy;䑇ckĀ;mᩇᩈ朓ark»ᩈ;䏇r΀;Ecefms᩟᩠ᩢᩫ᪤᪪᪮旋;槃ƀ;elᩩᩪᩭ䋆q;扗eɡᩴ\0\0᪈rrowĀlr᩼᪁eft;憺ight;憻ʀRSacd᪒᪔᪖᪚᪟»ཇ;擈st;抛irc;抚ash;抝nint;樐id;櫯cir;槂ubsĀ;u᪻᪼晣it»᪼ˬ᫇᫔᫺\0ᬊonĀ;eᫍᫎ䀺Ā;qÇÆɭ᫙\0\0᫢aĀ;t᫞᫟䀬;䁀ƀ;fl᫨᫩᫫戁îᅠeĀmx᫱᫶ent»᫩eóɍǧ᫾\0ᬇĀ;dኻᬂot;橭nôɆƀfryᬐᬔᬗ;쀀𝕔oäɔ脀©;sŕᬝr;愗Āaoᬥᬩrr;憵ss;朗Ācuᬲᬷr;쀀𝒸Ābpᬼ᭄Ā;eᭁᭂ櫏;櫑Ā;eᭉᭊ櫐;櫒dot;拯΀delprvw᭠᭬᭷ᮂᮬᯔ᯹arrĀlr᭨᭪;椸;椵ɰ᭲\0\0᭵r;拞c;拟arrĀ;p᭿ᮀ憶;椽̀;bcdosᮏᮐᮖᮡᮥᮨ截rcap;橈Āauᮛᮞp;橆p;橊ot;抍r;橅;쀀∪︀Ȁalrv᮵ᮿᯞᯣrrĀ;mᮼᮽ憷;椼yƀevwᯇᯔᯘqɰᯎ\0\0ᯒreã᭳uã᭵ee;拎edge;拏en耻¤䂤earrowĀlrᯮ᯳eft»ᮀight»ᮽeäᯝĀciᰁᰇoninôǷnt;戱lcty;挭ঀAHabcdefhijlorstuwz᰸᰻᰿ᱝᱩᱵᲊᲞᲬᲷ᳻᳿ᴍᵻᶑᶫᶻ᷆᷍rò΁ar;楥Ȁglrs᱈ᱍ᱒᱔ger;怠eth;愸òᄳhĀ;vᱚᱛ怐»ऊūᱡᱧarow;椏aã̕Āayᱮᱳron;䄏;䐴ƀ;ao̲ᱼᲄĀgrʿᲁr;懊tseq;橷ƀglmᲑᲔᲘ耻°䂰ta;䎴ptyv;榱ĀirᲣᲨsht;楿;쀀𝔡arĀlrᲳᲵ»ࣜ»သʀaegsv᳂͸᳖᳜᳠mƀ;oș᳊᳔ndĀ;ș᳑uit;晦amma;䏝in;拲ƀ;io᳧᳨᳸䃷de脀÷;o᳧ᳰntimes;拇nø᳷cy;䑒cɯᴆ\0\0ᴊrn;挞op;挍ʀlptuwᴘᴝᴢᵉᵕlar;䀤f;쀀𝕕ʀ;emps̋ᴭᴷᴽᵂqĀ;d͒ᴳot;扑inus;戸lus;戔quare;抡blebarwedgåúnƀadhᄮᵝᵧownarrowóᲃarpoonĀlrᵲᵶefôᲴighôᲶŢᵿᶅkaro÷གɯᶊ\0\0ᶎrn;挟op;挌ƀcotᶘᶣᶦĀryᶝᶡ;쀀𝒹;䑕l;槶rok;䄑Ādrᶰᶴot;拱iĀ;fᶺ᠖斿Āah᷀᷃ròЩaòྦangle;榦Āci᷒ᷕy;䑟grarr;柿ऀDacdefglmnopqrstuxḁḉḙḸոḼṉṡṾấắẽỡἪἷὄ὎὚ĀDoḆᴴoôᲉĀcsḎḔute耻é䃩ter;橮ȀaioyḢḧḱḶron;䄛rĀ;cḭḮ扖耻ê䃪lon;払;䑍ot;䄗ĀDrṁṅot;扒;쀀𝔢ƀ;rsṐṑṗ檚ave耻è䃨Ā;dṜṝ檖ot;檘Ȁ;ilsṪṫṲṴ檙nters;揧;愓Ā;dṹṺ檕ot;檗ƀapsẅẉẗcr;䄓tyƀ;svẒẓẕ戅et»ẓpĀ1;ẝẤĳạả;怄;怅怃ĀgsẪẬ;䅋p;怂ĀgpẴẸon;䄙f;쀀𝕖ƀalsỄỎỒrĀ;sỊị拕l;槣us;橱iƀ;lvỚớở䎵on»ớ;䏵ȀcsuvỪỳἋἣĀioữḱrc»Ḯɩỹ\0\0ỻíՈantĀglἂἆtr»ṝess»Ṻƀaeiἒ἖Ἒls;䀽st;扟vĀ;DȵἠD;橸parsl;槥ĀDaἯἳot;打rr;楱ƀcdiἾὁỸr;愯oô͒ĀahὉὋ;䎷耻ð䃰Āmrὓὗl耻ë䃫o;悬ƀcipὡὤὧl;䀡sôծĀeoὬὴctatioîՙnentialåչৡᾒ\0ᾞ\0ᾡᾧ\0\0ῆῌ\0ΐ\0ῦῪ \0 ⁚llingdotseñṄy;䑄male;晀ƀilrᾭᾳ῁lig;耀ﬃɩᾹ\0\0᾽g;耀ﬀig;耀ﬄ;쀀𝔣lig;耀ﬁlig;쀀fjƀaltῙ῜ῡt;晭ig;耀ﬂns;斱of;䆒ǰ΅\0ῳf;쀀𝕗ĀakֿῷĀ;vῼ´拔;櫙artint;樍Āao‌⁕Ācs‑⁒α‚‰‸⁅⁈\0⁐β•‥‧‪‬\0‮耻½䂽;慓耻¼䂼;慕;慙;慛Ƴ‴\0‶;慔;慖ʴ‾⁁\0\0⁃耻¾䂾;慗;慜5;慘ƶ⁌\0⁎;慚;慝8;慞l;恄wn;挢cr;쀀𝒻ࢀEabcdefgijlnorstv₂₉₟₥₰₴⃰⃵⃺⃿℃ℒℸ̗ℾ⅒↞Ā;lٍ₇;檌ƀcmpₐₕ₝ute;䇵maĀ;dₜ᳚䎳;檆reve;䄟Āiy₪₮rc;䄝;䐳ot;䄡Ȁ;lqsؾق₽⃉ƀ;qsؾٌ⃄lanô٥Ȁ;cdl٥⃒⃥⃕c;檩otĀ;o⃜⃝檀Ā;l⃢⃣檂;檄Ā;e⃪⃭쀀⋛︀s;檔r;쀀𝔤Ā;gٳ؛mel;愷cy;䑓Ȁ;Eajٚℌℎℐ;檒;檥;檤ȀEaesℛℝ℩ℴ;扩pĀ;p℣ℤ檊rox»ℤĀ;q℮ℯ檈Ā;q℮ℛim;拧pf;쀀𝕘Āci⅃ⅆr;愊mƀ;el٫ⅎ⅐;檎;檐茀>;cdlqr׮ⅠⅪⅮⅳⅹĀciⅥⅧ;檧r;橺ot;拗Par;榕uest;橼ʀadelsↄⅪ←ٖ↛ǰ↉\0↎proø₞r;楸qĀlqؿ↖lesó₈ií٫Āen↣↭rtneqq;쀀≩︀Å↪ԀAabcefkosy⇄⇇⇱⇵⇺∘∝∯≨≽ròΠȀilmr⇐⇔⇗⇛rsðᒄf»․ilôکĀdr⇠⇤cy;䑊ƀ;cwࣴ⇫⇯ir;楈;憭ar;意irc;䄥ƀalr∁∎∓rtsĀ;u∉∊晥it»∊lip;怦con;抹r;쀀𝔥sĀew∣∩arow;椥arow;椦ʀamopr∺∾≃≞≣rr;懿tht;戻kĀlr≉≓eftarrow;憩ightarrow;憪f;쀀𝕙bar;怕ƀclt≯≴≸r;쀀𝒽asè⇴rok;䄧Ābp⊂⊇ull;恃hen»ᱛૡ⊣\0⊪\0⊸⋅⋎\0⋕⋳\0\0⋸⌢⍧⍢⍿\0⎆⎪⎴cute耻í䃭ƀ;iyݱ⊰⊵rc耻î䃮;䐸Ācx⊼⊿y;䐵cl耻¡䂡ĀfrΟ⋉;쀀𝔦rave耻ì䃬Ȁ;inoܾ⋝⋩⋮Āin⋢⋦nt;樌t;戭fin;槜ta;愩lig;䄳ƀaop⋾⌚⌝ƀcgt⌅⌈⌗r;䄫ƀelpܟ⌏⌓inåގarôܠh;䄱f;抷ed;䆵ʀ;cfotӴ⌬⌱⌽⍁are;愅inĀ;t⌸⌹戞ie;槝doô⌙ʀ;celpݗ⍌⍐⍛⍡al;抺Āgr⍕⍙eróᕣã⍍arhk;樗rod;樼Ȁcgpt⍯⍲⍶⍻y;䑑on;䄯f;쀀𝕚a;䎹uest耻¿䂿Āci⎊⎏r;쀀𝒾nʀ;EdsvӴ⎛⎝⎡ӳ;拹ot;拵Ā;v⎦⎧拴;拳Ā;iݷ⎮lde;䄩ǫ⎸\0⎼cy;䑖l耻ï䃯̀cfmosu⏌⏗⏜⏡⏧⏵Āiy⏑⏕rc;䄵;䐹r;쀀𝔧ath;䈷pf;쀀𝕛ǣ⏬\0⏱r;쀀𝒿rcy;䑘kcy;䑔Ѐacfghjos␋␖␢␧␭␱␵␻ppaĀ;v␓␔䎺;䏰Āey␛␠dil;䄷;䐺r;쀀𝔨reen;䄸cy;䑅cy;䑜pf;쀀𝕜cr;쀀𝓀஀ABEHabcdefghjlmnoprstuv⑰⒁⒆⒍⒑┎┽╚▀♎♞♥♹♽⚚⚲⛘❝❨➋⟀⠁⠒ƀart⑷⑺⑼rò৆òΕail;椛arr;椎Ā;gঔ⒋;檋ar;楢ॣ⒥\0⒪\0⒱\0\0\0\0\0⒵Ⓔ\0ⓆⓈⓍ\0⓹ute;䄺mptyv;榴raîࡌbda;䎻gƀ;dlࢎⓁⓃ;榑åࢎ;檅uo耻«䂫rЀ;bfhlpst࢙ⓞⓦⓩ⓫⓮⓱⓵Ā;f࢝ⓣs;椟s;椝ë≒p;憫l;椹im;楳l;憢ƀ;ae⓿─┄檫il;椙Ā;s┉┊檭;쀀⪭︀ƀabr┕┙┝rr;椌rk;杲Āak┢┬cĀek┨┪;䁻;䁛Āes┱┳;榋lĀdu┹┻;榏;榍Ȁaeuy╆╋╖╘ron;䄾Ādi═╔il;䄼ìࢰâ┩;䐻Ȁcqrs╣╦╭╽a;椶uoĀ;rนᝆĀdu╲╷har;楧shar;楋h;憲ʀ;fgqs▋▌উ◳◿扤tʀahlrt▘▤▷◂◨rrowĀ;t࢙□aé⓶arpoonĀdu▯▴own»њp»०eftarrows;懇ightƀahs◍◖◞rrowĀ;sࣴࢧarpoonó྘quigarro÷⇰hreetimes;拋ƀ;qs▋ও◺lanôবʀ;cdgsব☊☍☝☨c;檨otĀ;o☔☕橿Ā;r☚☛檁;檃Ā;e☢☥쀀⋚︀s;檓ʀadegs☳☹☽♉♋pproøⓆot;拖qĀgq♃♅ôউgtò⒌ôছiíলƀilr♕࣡♚sht;楼;쀀𝔩Ā;Eজ♣;檑š♩♶rĀdu▲♮Ā;l॥♳;楪lk;斄cy;䑙ʀ;achtੈ⚈⚋⚑⚖rò◁orneòᴈard;楫ri;旺Āio⚟⚤dot;䅀ustĀ;a⚬⚭掰che»⚭ȀEaes⚻⚽⛉⛔;扨pĀ;p⛃⛄檉rox»⛄Ā;q⛎⛏檇Ā;q⛎⚻im;拦Ѐabnoptwz⛩⛴⛷✚✯❁❇❐Ānr⛮⛱g;柬r;懽rëࣁgƀlmr⛿✍✔eftĀar০✇ightá৲apsto;柼ightá৽parrowĀlr✥✩efô⓭ight;憬ƀafl✶✹✽r;榅;쀀𝕝us;樭imes;樴š❋❏st;戗áፎƀ;ef❗❘᠀旊nge»❘arĀ;l❤❥䀨t;榓ʀachmt❳❶❼➅➇ròࢨorneòᶌarĀ;d྘➃;業;怎ri;抿̀achiqt➘➝ੀ➢➮➻quo;怹r;쀀𝓁mƀ;egল➪➬;檍;檏Ābu┪➳oĀ;rฟ➹;怚rok;䅂萀<;cdhilqrࠫ⟒☹⟜⟠⟥⟪⟰Āci⟗⟙;檦r;橹reå◲mes;拉arr;楶uest;橻ĀPi⟵⟹ar;榖ƀ;ef⠀भ᠛旃rĀdu⠇⠍shar;楊har;楦Āen⠗⠡rtneqq;쀀≨︀Å⠞܀Dacdefhilnopsu⡀⡅⢂⢎⢓⢠⢥⢨⣚⣢⣤ઃ⣳⤂Dot;戺Ȁclpr⡎⡒⡣⡽r耻¯䂯Āet⡗⡙;時Ā;e⡞⡟朠se»⡟Ā;sျ⡨toȀ;dluျ⡳⡷⡻owîҌefôएðᏑker;斮Āoy⢇⢌mma;権;䐼ash;怔asuredangle»ᘦr;쀀𝔪o;愧ƀcdn⢯⢴⣉ro耻µ䂵Ȁ;acdᑤ⢽⣀⣄sôᚧir;櫰ot肻·Ƶusƀ;bd⣒ᤃ⣓戒Ā;uᴼ⣘;横ţ⣞⣡p;櫛ò−ðઁĀdp⣩⣮els;抧f;쀀𝕞Āct⣸⣽r;쀀𝓂pos»ᖝƀ;lm⤉⤊⤍䎼timap;抸ఀGLRVabcdefghijlmoprstuvw⥂⥓⥾⦉⦘⧚⧩⨕⨚⩘⩝⪃⪕⪤⪨⬄⬇⭄⭿⮮ⰴⱧⱼ⳩Āgt⥇⥋;쀀⋙̸Ā;v⥐௏쀀≫⃒ƀelt⥚⥲⥶ftĀar⥡⥧rrow;懍ightarrow;懎;쀀⋘̸Ā;v⥻ే쀀≪⃒ightarrow;懏ĀDd⦎⦓ash;抯ash;抮ʀbcnpt⦣⦧⦬⦱⧌la»˞ute;䅄g;쀀∠⃒ʀ;Eiop඄⦼⧀⧅⧈;쀀⩰̸d;쀀≋̸s;䅉roø඄urĀ;a⧓⧔普lĀ;s⧓ସǳ⧟\0⧣p肻 ଷmpĀ;e௹ఀʀaeouy⧴⧾⨃⨐⨓ǰ⧹\0⧻;橃on;䅈dil;䅆ngĀ;dൾ⨊ot;쀀⩭̸p;橂;䐽ash;怓΀;Aadqsxஒ⨩⨭⨻⩁⩅⩐rr;懗rĀhr⨳⨶k;椤Ā;oᏲᏰot;쀀≐̸uiöୣĀei⩊⩎ar;椨í஘istĀ;s஠டr;쀀𝔫ȀEest௅⩦⩹⩼ƀ;qs஼⩭௡ƀ;qs஼௅⩴lanô௢ií௪Ā;rஶ⪁»ஷƀAap⪊⪍⪑rò⥱rr;憮ar;櫲ƀ;svྍ⪜ྌĀ;d⪡⪢拼;拺cy;䑚΀AEadest⪷⪺⪾⫂⫅⫶⫹rò⥦;쀀≦̸rr;憚r;急Ȁ;fqs఻⫎⫣⫯tĀar⫔⫙rro÷⫁ightarro÷⪐ƀ;qs఻⪺⫪lanôౕĀ;sౕ⫴»శiíౝĀ;rవ⫾iĀ;eచథiäඐĀpt⬌⬑f;쀀𝕟膀¬;in⬙⬚⬶䂬nȀ;Edvஉ⬤⬨⬮;쀀⋹̸ot;쀀⋵̸ǡஉ⬳⬵;拷;拶iĀ;vಸ⬼ǡಸ⭁⭃;拾;拽ƀaor⭋⭣⭩rȀ;ast୻⭕⭚⭟lleì୻l;쀀⫽⃥;쀀∂̸lint;樔ƀ;ceಒ⭰⭳uåಥĀ;cಘ⭸Ā;eಒ⭽ñಘȀAait⮈⮋⮝⮧rò⦈rrƀ;cw⮔⮕⮙憛;쀀⤳̸;쀀↝̸ghtarrow»⮕riĀ;eೋೖ΀chimpqu⮽⯍⯙⬄୸⯤⯯Ȁ;cerല⯆ഷ⯉uå൅;쀀𝓃ortɭ⬅\0\0⯖ará⭖mĀ;e൮⯟Ā;q൴൳suĀbp⯫⯭å೸åഋƀbcp⯶ⰑⰙȀ;Ees⯿ⰀഢⰄ抄;쀀⫅̸etĀ;eഛⰋqĀ;qണⰀcĀ;eലⰗñസȀ;EesⰢⰣൟⰧ抅;쀀⫆̸etĀ;e൘ⰮqĀ;qൠⰣȀgilrⰽⰿⱅⱇìௗlde耻ñ䃱çృiangleĀlrⱒⱜeftĀ;eచⱚñదightĀ;eೋⱥñ೗Ā;mⱬⱭ䎽ƀ;esⱴⱵⱹ䀣ro;愖p;怇ҀDHadgilrsⲏⲔⲙⲞⲣⲰⲶⳓⳣash;抭arr;椄p;쀀≍⃒ash;抬ĀetⲨⲬ;쀀≥⃒;쀀>⃒nfin;槞ƀAetⲽⳁⳅrr;椂;쀀≤⃒Ā;rⳊⳍ쀀<⃒ie;쀀⊴⃒ĀAtⳘⳜrr;椃rie;쀀⊵⃒im;쀀∼⃒ƀAan⳰⳴ⴂrr;懖rĀhr⳺⳽k;椣Ā;oᏧᏥear;椧ቓ᪕\0\0\0\0\0\0\0\0\0\0\0\0\0ⴭ\0ⴸⵈⵠⵥ⵲ⶄᬇ\0\0ⶍⶫ\0ⷈⷎ\0ⷜ⸙⸫⸾⹃Ācsⴱ᪗ute耻ó䃳ĀiyⴼⵅrĀ;c᪞ⵂ耻ô䃴;䐾ʀabios᪠ⵒⵗǈⵚlac;䅑v;樸old;榼lig;䅓Ācr⵩⵭ir;榿;쀀𝔬ͯ⵹\0\0⵼\0ⶂn;䋛ave耻ò䃲;槁Ābmⶈ෴ar;榵Ȁacitⶕ⶘ⶥⶨrò᪀Āir⶝ⶠr;榾oss;榻nå๒;槀ƀaeiⶱⶵⶹcr;䅍ga;䏉ƀcdnⷀⷅǍron;䎿;榶pf;쀀𝕠ƀaelⷔ⷗ǒr;榷rp;榹΀;adiosvⷪⷫⷮ⸈⸍⸐⸖戨rò᪆Ȁ;efmⷷⷸ⸂⸅橝rĀ;oⷾⷿ愴f»ⷿ耻ª䂪耻º䂺gof;抶r;橖lope;橗;橛ƀclo⸟⸡⸧ò⸁ash耻ø䃸l;折iŬⸯ⸴de耻õ䃵esĀ;aǛ⸺s;樶ml耻ö䃶bar;挽ૡ⹞\0⹽\0⺀⺝\0⺢⺹\0\0⻋ຜ\0⼓\0\0⼫⾼\0⿈rȀ;astЃ⹧⹲຅脀¶;l⹭⹮䂶leìЃɩ⹸\0\0⹻m;櫳;櫽y;䐿rʀcimpt⺋⺏⺓ᡥ⺗nt;䀥od;䀮il;怰enk;怱r;쀀𝔭ƀimo⺨⺰⺴Ā;v⺭⺮䏆;䏕maô੶ne;明ƀ;tv⺿⻀⻈䏀chfork»´;䏖Āau⻏⻟nĀck⻕⻝kĀ;h⇴⻛;愎ö⇴sҀ;abcdemst⻳⻴ᤈ⻹⻽⼄⼆⼊⼎䀫cir;樣ir;樢Āouᵀ⼂;樥;橲n肻±ຝim;樦wo;樧ƀipu⼙⼠⼥ntint;樕f;쀀𝕡nd耻£䂣Ԁ;Eaceinosu່⼿⽁⽄⽇⾁⾉⾒⽾⾶;檳p;檷uå໙Ā;c໎⽌̀;acens່⽙⽟⽦⽨⽾pproø⽃urlyeñ໙ñ໎ƀaes⽯⽶⽺pprox;檹qq;檵im;拨iíໟmeĀ;s⾈ຮ怲ƀEas⽸⾐⽺ð⽵ƀdfp໬⾙⾯ƀals⾠⾥⾪lar;挮ine;挒urf;挓Ā;t໻⾴ï໻rel;抰Āci⿀⿅r;쀀𝓅;䏈ncsp;怈̀fiopsu⿚⋢⿟⿥⿫⿱r;쀀𝔮pf;쀀𝕢rime;恗cr;쀀𝓆ƀaeo⿸〉〓tĀei⿾々rnionóڰnt;樖stĀ;e【】䀿ñἙô༔઀ABHabcdefhilmnoprstux぀けさすムㄎㄫㅇㅢㅲㆎ㈆㈕㈤㈩㉘㉮㉲㊐㊰㊷ƀartぇおがròႳòϝail;検aròᱥar;楤΀cdenqrtとふへみわゔヌĀeuねぱ;쀀∽̱te;䅕iãᅮmptyv;榳gȀ;del࿑らるろ;榒;榥å࿑uo耻»䂻rր;abcfhlpstw࿜ガクシスゼゾダッデナp;極Ā;f࿠ゴs;椠;椳s;椞ë≝ð✮l;楅im;楴l;憣;憝Āaiパフil;椚oĀ;nホボ戶aló༞ƀabrョリヮrò៥rk;杳ĀakンヽcĀekヹ・;䁽;䁝Āes㄂㄄;榌lĀduㄊㄌ;榎;榐Ȁaeuyㄗㄜㄧㄩron;䅙Ādiㄡㄥil;䅗ì࿲âヺ;䑀Ȁclqsㄴㄷㄽㅄa;椷dhar;楩uoĀ;rȎȍh;憳ƀacgㅎㅟངlȀ;ipsླྀㅘㅛႜnåႻarôྩt;断ƀilrㅩဣㅮsht;楽;쀀𝔯ĀaoㅷㆆrĀduㅽㅿ»ѻĀ;l႑ㆄ;楬Ā;vㆋㆌ䏁;䏱ƀgns㆕ㇹㇼht̀ahlrstㆤㆰ㇂㇘㇤㇮rrowĀ;t࿜ㆭaéトarpoonĀduㆻㆿowîㅾp»႒eftĀah㇊㇐rrowó࿪arpoonóՑightarrows;應quigarro÷ニhreetimes;拌g;䋚ingdotseñἲƀahm㈍㈐㈓rò࿪aòՑ;怏oustĀ;a㈞㈟掱che»㈟mid;櫮Ȁabpt㈲㈽㉀㉒Ānr㈷㈺g;柭r;懾rëဃƀafl㉇㉊㉎r;榆;쀀𝕣us;樮imes;樵Āap㉝㉧rĀ;g㉣㉤䀩t;榔olint;樒arò㇣Ȁachq㉻㊀Ⴜ㊅quo;怺r;쀀𝓇Ābu・㊊oĀ;rȔȓƀhir㊗㊛㊠reåㇸmes;拊iȀ;efl㊪ၙᠡ㊫方tri;槎luhar;楨;愞ൡ㋕㋛㋟㌬㌸㍱\0㍺㎤\0\0㏬㏰\0㐨㑈㑚㒭㒱㓊㓱\0㘖\0\0㘳cute;䅛quï➺Ԁ;Eaceinpsyᇭ㋳㋵㋿㌂㌋㌏㌟㌦㌩;檴ǰ㋺\0㋼;檸on;䅡uåᇾĀ;dᇳ㌇il;䅟rc;䅝ƀEas㌖㌘㌛;檶p;檺im;择olint;樓iíሄ;䑁otƀ;be㌴ᵇ㌵担;橦΀Aacmstx㍆㍊㍗㍛㍞㍣㍭rr;懘rĀhr㍐㍒ë∨Ā;oਸ਼਴t耻§䂧i;䀻war;椩mĀin㍩ðnuóñt;朶rĀ;o㍶⁕쀀𝔰Ȁacoy㎂㎆㎑㎠rp;景Āhy㎋㎏cy;䑉;䑈rtɭ㎙\0\0㎜iäᑤaraì⹯耻­䂭Āgm㎨㎴maƀ;fv㎱㎲㎲䏃;䏂Ѐ;deglnprካ㏅㏉㏎㏖㏞㏡㏦ot;橪Ā;q኱ኰĀ;E㏓㏔檞;檠Ā;E㏛㏜檝;檟e;扆lus;樤arr;楲aròᄽȀaeit㏸㐈㐏㐗Āls㏽㐄lsetmé㍪hp;樳parsl;槤Ādlᑣ㐔e;挣Ā;e㐜㐝檪Ā;s㐢㐣檬;쀀⪬︀ƀflp㐮㐳㑂tcy;䑌Ā;b㐸㐹䀯Ā;a㐾㐿槄r;挿f;쀀𝕤aĀdr㑍ЂesĀ;u㑔㑕晠it»㑕ƀcsu㑠㑹㒟Āau㑥㑯pĀ;sᆈ㑫;쀀⊓︀pĀ;sᆴ㑵;쀀⊔︀uĀbp㑿㒏ƀ;esᆗᆜ㒆etĀ;eᆗ㒍ñᆝƀ;esᆨᆭ㒖etĀ;eᆨ㒝ñᆮƀ;afᅻ㒦ְrť㒫ֱ»ᅼaròᅈȀcemt㒹㒾㓂㓅r;쀀𝓈tmîñiì㐕aræᆾĀar㓎㓕rĀ;f㓔ឿ昆Āan㓚㓭ightĀep㓣㓪psiloîỠhé⺯s»⡒ʀbcmnp㓻㕞ሉ㖋㖎Ҁ;Edemnprs㔎㔏㔑㔕㔞㔣㔬㔱㔶抂;櫅ot;檽Ā;dᇚ㔚ot;櫃ult;櫁ĀEe㔨㔪;櫋;把lus;檿arr;楹ƀeiu㔽㕒㕕tƀ;en㔎㕅㕋qĀ;qᇚ㔏eqĀ;q㔫㔨m;櫇Ābp㕚㕜;櫕;櫓c̀;acensᇭ㕬㕲㕹㕻㌦pproø㋺urlyeñᇾñᇳƀaes㖂㖈㌛pproø㌚qñ㌗g;晪ڀ123;Edehlmnps㖩㖬㖯ሜ㖲㖴㗀㗉㗕㗚㗟㗨㗭耻¹䂹耻²䂲耻³䂳;櫆Āos㖹㖼t;檾ub;櫘Ā;dሢ㗅ot;櫄sĀou㗏㗒l;柉b;櫗arr;楻ult;櫂ĀEe㗤㗦;櫌;抋lus;櫀ƀeiu㗴㘉㘌tƀ;enሜ㗼㘂qĀ;qሢ㖲eqĀ;q㗧㗤m;櫈Ābp㘑㘓;櫔;櫖ƀAan㘜㘠㘭rr;懙rĀhr㘦㘨ë∮Ā;oਫ਩war;椪lig耻ß䃟௡㙑㙝㙠ዎ㙳㙹\0㙾㛂\0\0\0\0\0㛛㜃\0㜉㝬\0\0\0㞇ɲ㙖\0\0㙛get;挖;䏄rë๟ƀaey㙦㙫㙰ron;䅥dil;䅣;䑂lrec;挕r;쀀𝔱Ȁeiko㚆㚝㚵㚼ǲ㚋\0㚑eĀ4fኄኁaƀ;sv㚘㚙㚛䎸ym;䏑Ācn㚢㚲kĀas㚨㚮pproø዁im»ኬsðኞĀas㚺㚮ð዁rn耻þ䃾Ǭ̟㛆⋧es膀×;bd㛏㛐㛘䃗Ā;aᤏ㛕r;樱;樰ƀeps㛡㛣㜀á⩍Ȁ;bcf҆㛬㛰㛴ot;挶ir;櫱Ā;o㛹㛼쀀𝕥rk;櫚á㍢rime;怴ƀaip㜏㜒㝤dåቈ΀adempst㜡㝍㝀㝑㝗㝜㝟ngleʀ;dlqr㜰㜱㜶㝀㝂斵own»ᶻeftĀ;e⠀㜾ñम;扜ightĀ;e㊪㝋ñၚot;旬inus;樺lus;樹b;槍ime;樻ezium;揢ƀcht㝲㝽㞁Āry㝷㝻;쀀𝓉;䑆cy;䑛rok;䅧Āio㞋㞎xô᝷headĀlr㞗㞠eftarro÷ࡏightarrow»ཝऀAHabcdfghlmoprstuw㟐㟓㟗㟤㟰㟼㠎㠜㠣㠴㡑㡝㡫㢩㣌㣒㣪㣶ròϭar;楣Ācr㟜㟢ute耻ú䃺òᅐrǣ㟪\0㟭y;䑞ve;䅭Āiy㟵㟺rc耻û䃻;䑃ƀabh㠃㠆㠋ròᎭlac;䅱aòᏃĀir㠓㠘sht;楾;쀀𝔲rave耻ù䃹š㠧㠱rĀlr㠬㠮»ॗ»ႃlk;斀Āct㠹㡍ɯ㠿\0\0㡊rnĀ;e㡅㡆挜r»㡆op;挏ri;旸Āal㡖㡚cr;䅫肻¨͉Āgp㡢㡦on;䅳f;쀀𝕦̀adhlsuᅋ㡸㡽፲㢑㢠ownáᎳarpoonĀlr㢈㢌efô㠭ighô㠯iƀ;hl㢙㢚㢜䏅»ᏺon»㢚parrows;懈ƀcit㢰㣄㣈ɯ㢶\0\0㣁rnĀ;e㢼㢽挝r»㢽op;挎ng;䅯ri;旹cr;쀀𝓊ƀdir㣙㣝㣢ot;拰lde;䅩iĀ;f㜰㣨»᠓Āam㣯㣲rò㢨l耻ü䃼angle;榧ހABDacdeflnoprsz㤜㤟㤩㤭㦵㦸㦽㧟㧤㧨㧳㧹㧽㨁㨠ròϷarĀ;v㤦㤧櫨;櫩asèϡĀnr㤲㤷grt;榜΀eknprst㓣㥆㥋㥒㥝㥤㦖appá␕othinçẖƀhir㓫⻈㥙opô⾵Ā;hᎷ㥢ïㆍĀiu㥩㥭gmá㎳Ābp㥲㦄setneqĀ;q㥽㦀쀀⊊︀;쀀⫋︀setneqĀ;q㦏㦒쀀⊋︀;쀀⫌︀Āhr㦛㦟etá㚜iangleĀlr㦪㦯eft»थight»ၑy;䐲ash»ံƀelr㧄㧒㧗ƀ;beⷪ㧋㧏ar;抻q;扚lip;拮Ābt㧜ᑨaòᑩr;쀀𝔳tré㦮suĀbp㧯㧱»ജ»൙pf;쀀𝕧roð໻tré㦴Ācu㨆㨋r;쀀𝓋Ābp㨐㨘nĀEe㦀㨖»㥾nĀEe㦒㨞»㦐igzag;榚΀cefoprs㨶㨻㩖㩛㩔㩡㩪irc;䅵Ādi㩀㩑Ābg㩅㩉ar;機eĀ;qᗺ㩏;扙erp;愘r;쀀𝔴pf;쀀𝕨Ā;eᑹ㩦atèᑹcr;쀀𝓌ૣណ㪇\0㪋\0㪐㪛\0\0㪝㪨㪫㪯\0\0㫃㫎\0㫘ៜ៟tré៑r;쀀𝔵ĀAa㪔㪗ròσrò৶;䎾ĀAa㪡㪤ròθrò৫að✓is;拻ƀdptឤ㪵㪾Āfl㪺ឩ;쀀𝕩imåឲĀAa㫇㫊ròώròਁĀcq㫒ីr;쀀𝓍Āpt៖㫜ré។Ѐacefiosu㫰㫽㬈㬌㬑㬕㬛㬡cĀuy㫶㫻te耻ý䃽;䑏Āiy㬂㬆rc;䅷;䑋n耻¥䂥r;쀀𝔶cy;䑗pf;쀀𝕪cr;쀀𝓎Ācm㬦㬩y;䑎l耻ÿ䃿Ԁacdefhiosw㭂㭈㭔㭘㭤㭩㭭㭴㭺㮀cute;䅺Āay㭍㭒ron;䅾;䐷ot;䅼Āet㭝㭡træᕟa;䎶r;쀀𝔷cy;䐶grarr;懝pf;쀀𝕫cr;쀀𝓏Ājn㮅㮇;怍j;怌'.split("").map((u) => u.charCodeAt(0))
), j0 = new Uint16Array(
  // prettier-ignore
  "Ȁaglq	\x1Bɭ\0\0p;䀦os;䀧t;䀾t;䀼uot;䀢".split("").map((u) => u.charCodeAt(0))
);
var lu;
const $0 = /* @__PURE__ */ new Map([
  [0, 65533],
  // C1 Unicode control character reference replacements
  [128, 8364],
  [130, 8218],
  [131, 402],
  [132, 8222],
  [133, 8230],
  [134, 8224],
  [135, 8225],
  [136, 710],
  [137, 8240],
  [138, 352],
  [139, 8249],
  [140, 338],
  [142, 381],
  [145, 8216],
  [146, 8217],
  [147, 8220],
  [148, 8221],
  [149, 8226],
  [150, 8211],
  [151, 8212],
  [152, 732],
  [153, 8482],
  [154, 353],
  [155, 8250],
  [156, 339],
  [158, 382],
  [159, 376]
]), U0 = (
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
  (lu = String.fromCodePoint) !== null && lu !== void 0 ? lu : function(u) {
    let e = "";
    return u > 65535 && (u -= 65536, e += String.fromCharCode(u >>> 10 & 1023 | 55296), u = 56320 | u & 1023), e += String.fromCharCode(u), e;
  }
);
function Z0(u) {
  var e;
  return u >= 55296 && u <= 57343 || u > 1114111 ? 65533 : (e = $0.get(u)) !== null && e !== void 0 ? e : u;
}
var A;
(function(u) {
  u[u.NUM = 35] = "NUM", u[u.SEMI = 59] = "SEMI", u[u.EQUALS = 61] = "EQUALS", u[u.ZERO = 48] = "ZERO", u[u.NINE = 57] = "NINE", u[u.LOWER_A = 97] = "LOWER_A", u[u.LOWER_F = 102] = "LOWER_F", u[u.LOWER_X = 120] = "LOWER_X", u[u.LOWER_Z = 122] = "LOWER_Z", u[u.UPPER_A = 65] = "UPPER_A", u[u.UPPER_F = 70] = "UPPER_F", u[u.UPPER_Z = 90] = "UPPER_Z";
})(A || (A = {}));
const H0 = 32;
var O;
(function(u) {
  u[u.VALUE_LENGTH = 49152] = "VALUE_LENGTH", u[u.BRANCH_LENGTH = 16256] = "BRANCH_LENGTH", u[u.JUMP_TABLE = 127] = "JUMP_TABLE";
})(O || (O = {}));
function mu(u) {
  return u >= A.ZERO && u <= A.NINE;
}
function V0(u) {
  return u >= A.UPPER_A && u <= A.UPPER_F || u >= A.LOWER_A && u <= A.LOWER_F;
}
function G0(u) {
  return u >= A.UPPER_A && u <= A.UPPER_Z || u >= A.LOWER_A && u <= A.LOWER_Z || mu(u);
}
function W0(u) {
  return u === A.EQUALS || G0(u);
}
var F;
(function(u) {
  u[u.EntityStart = 0] = "EntityStart", u[u.NumericStart = 1] = "NumericStart", u[u.NumericDecimal = 2] = "NumericDecimal", u[u.NumericHex = 3] = "NumericHex", u[u.NamedEntity = 4] = "NamedEntity";
})(F || (F = {}));
var P;
(function(u) {
  u[u.Legacy = 0] = "Legacy", u[u.Strict = 1] = "Strict", u[u.Attribute = 2] = "Attribute";
})(P || (P = {}));
class J0 {
  constructor(e, r, c) {
    this.decodeTree = e, this.emitCodePoint = r, this.errors = c, this.state = F.EntityStart, this.consumed = 1, this.result = 0, this.treeIndex = 0, this.excess = 1, this.decodeMode = P.Strict;
  }
  /** Resets the instance to make it reusable. */
  startEntity(e) {
    this.decodeMode = e, this.state = F.EntityStart, this.result = 0, this.treeIndex = 0, this.excess = 1, this.consumed = 1;
  }
  /**
   * Write an entity to the decoder. This can be called multiple times with partial entities.
   * If the entity is incomplete, the decoder will return -1.
   *
   * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
   * entity is incomplete, and resume when the next string is written.
   *
   * @param string The string containing the entity (or a continuation of the entity).
   * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  write(e, r) {
    switch (this.state) {
      case F.EntityStart:
        return e.charCodeAt(r) === A.NUM ? (this.state = F.NumericStart, this.consumed += 1, this.stateNumericStart(e, r + 1)) : (this.state = F.NamedEntity, this.stateNamedEntity(e, r));
      case F.NumericStart:
        return this.stateNumericStart(e, r);
      case F.NumericDecimal:
        return this.stateNumericDecimal(e, r);
      case F.NumericHex:
        return this.stateNumericHex(e, r);
      case F.NamedEntity:
        return this.stateNamedEntity(e, r);
    }
  }
  /**
   * Switches between the numeric decimal and hexadecimal states.
   *
   * Equivalent to the `Numeric character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericStart(e, r) {
    return r >= e.length ? -1 : (e.charCodeAt(r) | H0) === A.LOWER_X ? (this.state = F.NumericHex, this.consumed += 1, this.stateNumericHex(e, r + 1)) : (this.state = F.NumericDecimal, this.stateNumericDecimal(e, r));
  }
  addToNumericResult(e, r, c, n) {
    if (r !== c) {
      const t = c - r;
      this.result = this.result * Math.pow(n, t) + parseInt(e.substr(r, t), n), this.consumed += t;
    }
  }
  /**
   * Parses a hexadecimal numeric entity.
   *
   * Equivalent to the `Hexademical character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericHex(e, r) {
    const c = r;
    for (; r < e.length; ) {
      const n = e.charCodeAt(r);
      if (mu(n) || V0(n))
        r += 1;
      else
        return this.addToNumericResult(e, c, r, 16), this.emitNumericEntity(n, 3);
    }
    return this.addToNumericResult(e, c, r, 16), -1;
  }
  /**
   * Parses a decimal numeric entity.
   *
   * Equivalent to the `Decimal character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericDecimal(e, r) {
    const c = r;
    for (; r < e.length; ) {
      const n = e.charCodeAt(r);
      if (mu(n))
        r += 1;
      else
        return this.addToNumericResult(e, c, r, 10), this.emitNumericEntity(n, 2);
    }
    return this.addToNumericResult(e, c, r, 10), -1;
  }
  /**
   * Validate and emit a numeric entity.
   *
   * Implements the logic from the `Hexademical character reference start
   * state` and `Numeric character reference end state` in the HTML spec.
   *
   * @param lastCp The last code point of the entity. Used to see if the
   *               entity was terminated with a semicolon.
   * @param expectedLength The minimum number of characters that should be
   *                       consumed. Used to validate that at least one digit
   *                       was consumed.
   * @returns The number of characters that were consumed.
   */
  emitNumericEntity(e, r) {
    var c;
    if (this.consumed <= r)
      return (c = this.errors) === null || c === void 0 || c.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
    if (e === A.SEMI)
      this.consumed += 1;
    else if (this.decodeMode === P.Strict)
      return 0;
    return this.emitCodePoint(Z0(this.result), this.consumed), this.errors && (e !== A.SEMI && this.errors.missingSemicolonAfterCharacterReference(), this.errors.validateNumericCharacterReference(this.result)), this.consumed;
  }
  /**
   * Parses a named entity.
   *
   * Equivalent to the `Named character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNamedEntity(e, r) {
    const { decodeTree: c } = this;
    let n = c[this.treeIndex], t = (n & O.VALUE_LENGTH) >> 14;
    for (; r < e.length; r++, this.excess++) {
      const o = e.charCodeAt(r);
      if (this.treeIndex = Q0(c, n, this.treeIndex + Math.max(1, t), o), this.treeIndex < 0)
        return this.result === 0 || // If we are parsing an attribute
        this.decodeMode === P.Attribute && // We shouldn't have consumed any characters after the entity,
        (t === 0 || // And there should be no invalid characters.
        W0(o)) ? 0 : this.emitNotTerminatedNamedEntity();
      if (n = c[this.treeIndex], t = (n & O.VALUE_LENGTH) >> 14, t !== 0) {
        if (o === A.SEMI)
          return this.emitNamedEntityData(this.treeIndex, t, this.consumed + this.excess);
        this.decodeMode !== P.Strict && (this.result = this.treeIndex, this.consumed += this.excess, this.excess = 0);
      }
    }
    return -1;
  }
  /**
   * Emit a named entity that was not terminated with a semicolon.
   *
   * @returns The number of characters consumed.
   */
  emitNotTerminatedNamedEntity() {
    var e;
    const { result: r, decodeTree: c } = this, n = (c[r] & O.VALUE_LENGTH) >> 14;
    return this.emitNamedEntityData(r, n, this.consumed), (e = this.errors) === null || e === void 0 || e.missingSemicolonAfterCharacterReference(), this.consumed;
  }
  /**
   * Emit a named entity.
   *
   * @param result The index of the entity in the decode tree.
   * @param valueLength The number of bytes in the entity.
   * @param consumed The number of characters consumed.
   *
   * @returns The number of characters consumed.
   */
  emitNamedEntityData(e, r, c) {
    const { decodeTree: n } = this;
    return this.emitCodePoint(r === 1 ? n[e] & ~O.VALUE_LENGTH : n[e + 1], c), r === 3 && this.emitCodePoint(n[e + 2], c), c;
  }
  /**
   * Signal to the parser that the end of the input was reached.
   *
   * Remaining data will be emitted and relevant errors will be produced.
   *
   * @returns The number of characters consumed.
   */
  end() {
    var e;
    switch (this.state) {
      case F.NamedEntity:
        return this.result !== 0 && (this.decodeMode !== P.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
      case F.NumericDecimal:
        return this.emitNumericEntity(0, 2);
      case F.NumericHex:
        return this.emitNumericEntity(0, 3);
      case F.NumericStart:
        return (e = this.errors) === null || e === void 0 || e.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
      case F.EntityStart:
        return 0;
    }
  }
}
function Yu(u) {
  let e = "";
  const r = new J0(u, (c) => e += U0(c));
  return function(n, t) {
    let o = 0, i = 0;
    for (; (i = n.indexOf("&", i)) >= 0; ) {
      e += n.slice(o, i), r.startEntity(t);
      const s = r.write(
        n,
        // Skip the "&"
        i + 1
      );
      if (s < 0) {
        o = i + r.end();
        break;
      }
      o = i + s, i = s === 0 ? o + 1 : o;
    }
    const a = e + n.slice(o);
    return e = "", a;
  };
}
function Q0(u, e, r, c) {
  const n = (e & O.BRANCH_LENGTH) >> 7, t = e & O.JUMP_TABLE;
  if (n === 0)
    return t !== 0 && c === t ? r : -1;
  if (t) {
    const a = c - t;
    return a < 0 || a >= n ? -1 : u[r + a] - 1;
  }
  let o = r, i = o + n - 1;
  for (; o <= i; ) {
    const a = o + i >>> 1, s = u[a];
    if (s < c)
      o = a + 1;
    else if (s > c)
      i = a - 1;
    else
      return u[a + n];
  }
  return -1;
}
const X0 = Yu(N0);
Yu(j0);
function Ku(u, e = P.Legacy) {
  return X0(u, e);
}
function Y0(u) {
  return Object.prototype.toString.call(u);
}
function Fu(u) {
  return Y0(u) === "[object String]";
}
const K0 = Object.prototype.hasOwnProperty;
function ue(u, e) {
  return K0.call(u, e);
}
function iu(u) {
  return Array.prototype.slice.call(arguments, 1).forEach(function(r) {
    if (r) {
      if (typeof r != "object")
        throw new TypeError(r + "must be object");
      Object.keys(r).forEach(function(c) {
        u[c] = r[c];
      });
    }
  }), u;
}
function u0(u, e, r) {
  return [].concat(u.slice(0, e), r, u.slice(e + 1));
}
function Au(u) {
  return !(u >= 55296 && u <= 57343 || u >= 64976 && u <= 65007 || (u & 65535) === 65535 || (u & 65535) === 65534 || u >= 0 && u <= 8 || u === 11 || u >= 14 && u <= 31 || u >= 127 && u <= 159 || u > 1114111);
}
function tu(u) {
  if (u > 65535) {
    u -= 65536;
    const e = 55296 + (u >> 10), r = 56320 + (u & 1023);
    return String.fromCharCode(e, r);
  }
  return String.fromCharCode(u);
}
const e0 = /\\([!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~])/g, ee = /&([a-z#][a-z0-9]{1,31});/gi, re = new RegExp(e0.source + "|" + ee.source, "gi"), ne = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))$/i;
function te(u, e) {
  if (e.charCodeAt(0) === 35 && ne.test(e)) {
    const c = e[1].toLowerCase() === "x" ? parseInt(e.slice(2), 16) : parseInt(e.slice(1), 10);
    return Au(c) ? tu(c) : u;
  }
  const r = Ku(u);
  return r !== u ? r : u;
}
function ce(u) {
  return u.indexOf("\\") < 0 ? u : u.replace(e0, "$1");
}
function H(u) {
  return u.indexOf("\\") < 0 && u.indexOf("&") < 0 ? u : u.replace(re, function(e, r, c) {
    return r || te(e, c);
  });
}
const ie = /[&<>"]/, oe = /[&<>"]/g, ae = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;"
};
function se(u) {
  return ae[u];
}
function N(u) {
  return ie.test(u) ? u.replace(oe, se) : u;
}
const fe = /[.?*+^$[\]\\(){}|-]/g;
function le(u) {
  return u.replace(fe, "\\$&");
}
function E(u) {
  switch (u) {
    case 9:
    case 32:
      return !0;
  }
  return !1;
}
function W(u) {
  if (u >= 8192 && u <= 8202)
    return !0;
  switch (u) {
    case 9:
    case 10:
    case 11:
    case 12:
    case 13:
    case 32:
    case 160:
    case 5760:
    case 8239:
    case 8287:
    case 12288:
      return !0;
  }
  return !1;
}
function J(u) {
  return Eu.test(u) || Qu.test(u);
}
function Q(u) {
  switch (u) {
    case 33:
    case 34:
    case 35:
    case 36:
    case 37:
    case 38:
    case 39:
    case 40:
    case 41:
    case 42:
    case 43:
    case 44:
    case 45:
    case 46:
    case 47:
    case 58:
    case 59:
    case 60:
    case 61:
    case 62:
    case 63:
    case 64:
    case 91:
    case 92:
    case 93:
    case 94:
    case 95:
    case 96:
    case 123:
    case 124:
    case 125:
    case 126:
      return !0;
    default:
      return !1;
  }
}
function ou(u) {
  return u = u.trim().replace(/\s+/g, " "), "ẞ".toLowerCase() === "Ṿ" && (u = u.replace(/ẞ/g, "ß")), u.toLowerCase().toUpperCase();
}
const de = { mdurl: L0, ucmicro: O0 }, he = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  arrayReplaceAt: u0,
  assign: iu,
  escapeHtml: N,
  escapeRE: le,
  fromCodePoint: tu,
  has: ue,
  isMdAsciiPunct: Q,
  isPunctChar: J,
  isSpace: E,
  isString: Fu,
  isValidEntityCode: Au,
  isWhiteSpace: W,
  lib: de,
  normalizeReference: ou,
  unescapeAll: H,
  unescapeMd: ce
}, Symbol.toStringTag, { value: "Module" }));
function be(u, e, r) {
  let c, n, t, o;
  const i = u.posMax, a = u.pos;
  for (u.pos = e + 1, c = 1; u.pos < i; ) {
    if (t = u.src.charCodeAt(u.pos), t === 93 && (c--, c === 0)) {
      n = !0;
      break;
    }
    if (o = u.pos, u.md.inline.skipToken(u), t === 91) {
      if (o === u.pos - 1)
        c++;
      else if (r)
        return u.pos = a, -1;
    }
  }
  let s = -1;
  return n && (s = u.pos), u.pos = a, s;
}
function pe(u, e, r) {
  let c, n = e;
  const t = {
    ok: !1,
    pos: 0,
    str: ""
  };
  if (u.charCodeAt(n) === 60) {
    for (n++; n < r; ) {
      if (c = u.charCodeAt(n), c === 10 || c === 60)
        return t;
      if (c === 62)
        return t.pos = n + 1, t.str = H(u.slice(e + 1, n)), t.ok = !0, t;
      if (c === 92 && n + 1 < r) {
        n += 2;
        continue;
      }
      n++;
    }
    return t;
  }
  let o = 0;
  for (; n < r && (c = u.charCodeAt(n), !(c === 32 || c < 32 || c === 127)); ) {
    if (c === 92 && n + 1 < r) {
      if (u.charCodeAt(n + 1) === 32)
        break;
      n += 2;
      continue;
    }
    if (c === 40 && (o++, o > 32))
      return t;
    if (c === 41) {
      if (o === 0)
        break;
      o--;
    }
    n++;
  }
  return e === n || o !== 0 || (t.str = H(u.slice(e, n)), t.pos = n, t.ok = !0), t;
}
function xe(u, e, r, c) {
  let n, t = e;
  const o = {
    // if `true`, this is a valid link title
    ok: !1,
    // if `true`, this link can be continued on the next line
    can_continue: !1,
    // if `ok`, it's the position of the first character after the closing marker
    pos: 0,
    // if `ok`, it's the unescaped title
    str: "",
    // expected closing marker character code
    marker: 0
  };
  if (c)
    o.str = c.str, o.marker = c.marker;
  else {
    if (t >= r)
      return o;
    let i = u.charCodeAt(t);
    if (i !== 34 && i !== 39 && i !== 40)
      return o;
    e++, t++, i === 40 && (i = 41), o.marker = i;
  }
  for (; t < r; ) {
    if (n = u.charCodeAt(t), n === o.marker)
      return o.pos = t + 1, o.str += H(u.slice(e, t)), o.ok = !0, o;
    if (n === 40 && o.marker === 41)
      return o;
    n === 92 && t + 1 < r && t++, t++;
  }
  return o.can_continue = !0, o.str += H(u.slice(e, t)), o;
}
const _e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  parseLinkDestination: pe,
  parseLinkLabel: be,
  parseLinkTitle: xe
}, Symbol.toStringTag, { value: "Module" })), M = {};
M.code_inline = function(u, e, r, c, n) {
  const t = u[e];
  return "<code" + n.renderAttrs(t) + ">" + N(t.content) + "</code>";
};
M.code_block = function(u, e, r, c, n) {
  const t = u[e];
  return "<pre" + n.renderAttrs(t) + "><code>" + N(u[e].content) + `</code></pre>
`;
};
M.fence = function(u, e, r, c, n) {
  const t = u[e], o = t.info ? H(t.info).trim() : "";
  let i = "", a = "";
  if (o) {
    const f = o.split(/(\s+)/g);
    i = f[0], a = f.slice(2).join("");
  }
  let s;
  if (r.highlight ? s = r.highlight(t.content, i, a) || N(t.content) : s = N(t.content), s.indexOf("<pre") === 0)
    return s + `
`;
  if (o) {
    const f = t.attrIndex("class"), d = t.attrs ? t.attrs.slice() : [];
    f < 0 ? d.push(["class", r.langPrefix + i]) : (d[f] = d[f].slice(), d[f][1] += " " + r.langPrefix + i);
    const b = {
      attrs: d
    };
    return `<pre><code${n.renderAttrs(b)}>${s}</code></pre>
`;
  }
  return `<pre><code${n.renderAttrs(t)}>${s}</code></pre>
`;
};
M.image = function(u, e, r, c, n) {
  const t = u[e];
  return t.attrs[t.attrIndex("alt")][1] = n.renderInlineAsText(t.children, r, c), n.renderToken(u, e, r);
};
M.hardbreak = function(u, e, r) {
  return r.xhtmlOut ? `<br />
` : `<br>
`;
};
M.softbreak = function(u, e, r) {
  return r.breaks ? r.xhtmlOut ? `<br />
` : `<br>
` : `
`;
};
M.text = function(u, e) {
  return N(u[e].content);
};
M.html_block = function(u, e) {
  return u[e].content;
};
M.html_inline = function(u, e) {
  return u[e].content;
};
function V() {
  this.rules = iu({}, M);
}
V.prototype.renderAttrs = function(e) {
  let r, c, n;
  if (!e.attrs)
    return "";
  for (n = "", r = 0, c = e.attrs.length; r < c; r++)
    n += " " + N(e.attrs[r][0]) + '="' + N(e.attrs[r][1]) + '"';
  return n;
};
V.prototype.renderToken = function(e, r, c) {
  const n = e[r];
  let t = "";
  if (n.hidden)
    return "";
  n.block && n.nesting !== -1 && r && e[r - 1].hidden && (t += `
`), t += (n.nesting === -1 ? "</" : "<") + n.tag, t += this.renderAttrs(n), n.nesting === 0 && c.xhtmlOut && (t += " /");
  let o = !1;
  if (n.block && (o = !0, n.nesting === 1 && r + 1 < e.length)) {
    const i = e[r + 1];
    (i.type === "inline" || i.hidden || i.nesting === -1 && i.tag === n.tag) && (o = !1);
  }
  return t += o ? `>
` : ">", t;
};
V.prototype.renderInline = function(u, e, r) {
  let c = "";
  const n = this.rules;
  for (let t = 0, o = u.length; t < o; t++) {
    const i = u[t].type;
    typeof n[i] < "u" ? c += n[i](u, t, e, r, this) : c += this.renderToken(u, t, e);
  }
  return c;
};
V.prototype.renderInlineAsText = function(u, e, r) {
  let c = "";
  for (let n = 0, t = u.length; n < t; n++)
    switch (u[n].type) {
      case "text":
        c += u[n].content;
        break;
      case "image":
        c += this.renderInlineAsText(u[n].children, e, r);
        break;
      case "html_inline":
      case "html_block":
        c += u[n].content;
        break;
      case "softbreak":
      case "hardbreak":
        c += `
`;
        break;
    }
  return c;
};
V.prototype.render = function(u, e, r) {
  let c = "";
  const n = this.rules;
  for (let t = 0, o = u.length; t < o; t++) {
    const i = u[t].type;
    i === "inline" ? c += this.renderInline(u[t].children, e, r) : typeof n[i] < "u" ? c += n[i](u, t, e, r, this) : c += this.renderToken(u, t, e, r);
  }
  return c;
};
function S() {
  this.__rules__ = [], this.__cache__ = null;
}
S.prototype.__find__ = function(u) {
  for (let e = 0; e < this.__rules__.length; e++)
    if (this.__rules__[e].name === u)
      return e;
  return -1;
};
S.prototype.__compile__ = function() {
  const u = this, e = [""];
  u.__rules__.forEach(function(r) {
    r.enabled && r.alt.forEach(function(c) {
      e.indexOf(c) < 0 && e.push(c);
    });
  }), u.__cache__ = {}, e.forEach(function(r) {
    u.__cache__[r] = [], u.__rules__.forEach(function(c) {
      c.enabled && (r && c.alt.indexOf(r) < 0 || u.__cache__[r].push(c.fn));
    });
  });
};
S.prototype.at = function(u, e, r) {
  const c = this.__find__(u), n = r || {};
  if (c === -1)
    throw new Error("Parser rule not found: " + u);
  this.__rules__[c].fn = e, this.__rules__[c].alt = n.alt || [], this.__cache__ = null;
};
S.prototype.before = function(u, e, r, c) {
  const n = this.__find__(u), t = c || {};
  if (n === -1)
    throw new Error("Parser rule not found: " + u);
  this.__rules__.splice(n, 0, {
    name: e,
    enabled: !0,
    fn: r,
    alt: t.alt || []
  }), this.__cache__ = null;
};
S.prototype.after = function(u, e, r, c) {
  const n = this.__find__(u), t = c || {};
  if (n === -1)
    throw new Error("Parser rule not found: " + u);
  this.__rules__.splice(n + 1, 0, {
    name: e,
    enabled: !0,
    fn: r,
    alt: t.alt || []
  }), this.__cache__ = null;
};
S.prototype.push = function(u, e, r) {
  const c = r || {};
  this.__rules__.push({
    name: u,
    enabled: !0,
    fn: e,
    alt: c.alt || []
  }), this.__cache__ = null;
};
S.prototype.enable = function(u, e) {
  Array.isArray(u) || (u = [u]);
  const r = [];
  return u.forEach(function(c) {
    const n = this.__find__(c);
    if (n < 0) {
      if (e)
        return;
      throw new Error("Rules manager: invalid rule name " + c);
    }
    this.__rules__[n].enabled = !0, r.push(c);
  }, this), this.__cache__ = null, r;
};
S.prototype.enableOnly = function(u, e) {
  Array.isArray(u) || (u = [u]), this.__rules__.forEach(function(r) {
    r.enabled = !1;
  }), this.enable(u, e);
};
S.prototype.disable = function(u, e) {
  Array.isArray(u) || (u = [u]);
  const r = [];
  return u.forEach(function(c) {
    const n = this.__find__(c);
    if (n < 0) {
      if (e)
        return;
      throw new Error("Rules manager: invalid rule name " + c);
    }
    this.__rules__[n].enabled = !1, r.push(c);
  }, this), this.__cache__ = null, r;
};
S.prototype.getRules = function(u) {
  return this.__cache__ === null && this.__compile__(), this.__cache__[u] || [];
};
function T(u, e, r) {
  this.type = u, this.tag = e, this.attrs = null, this.map = null, this.nesting = r, this.level = 0, this.children = null, this.content = "", this.markup = "", this.info = "", this.meta = null, this.block = !1, this.hidden = !1;
}
T.prototype.attrIndex = function(e) {
  if (!this.attrs)
    return -1;
  const r = this.attrs;
  for (let c = 0, n = r.length; c < n; c++)
    if (r[c][0] === e)
      return c;
  return -1;
};
T.prototype.attrPush = function(e) {
  this.attrs ? this.attrs.push(e) : this.attrs = [e];
};
T.prototype.attrSet = function(e, r) {
  const c = this.attrIndex(e), n = [e, r];
  c < 0 ? this.attrPush(n) : this.attrs[c] = n;
};
T.prototype.attrGet = function(e) {
  const r = this.attrIndex(e);
  let c = null;
  return r >= 0 && (c = this.attrs[r][1]), c;
};
T.prototype.attrJoin = function(e, r) {
  const c = this.attrIndex(e);
  c < 0 ? this.attrPush([e, r]) : this.attrs[c][1] = this.attrs[c][1] + " " + r;
};
function r0(u, e, r) {
  this.src = u, this.env = r, this.tokens = [], this.inlineMode = !1, this.md = e;
}
r0.prototype.Token = T;
const me = /\r\n?|\n/g, ke = /\0/g;
function ge(u) {
  let e;
  e = u.src.replace(me, `
`), e = e.replace(ke, "�"), u.src = e;
}
function De(u) {
  let e;
  u.inlineMode ? (e = new u.Token("inline", "", 0), e.content = u.src, e.map = [0, 1], e.children = [], u.tokens.push(e)) : u.md.block.parse(u.src, u.md, u.env, u.tokens);
}
function Ce(u) {
  const e = u.tokens;
  for (let r = 0, c = e.length; r < c; r++) {
    const n = e[r];
    n.type === "inline" && u.md.inline.parse(n.content, u.md, u.env, n.children);
  }
}
function Ee(u) {
  return /^<a[>\s]/i.test(u);
}
function Fe(u) {
  return /^<\/a\s*>/i.test(u);
}
function Ae(u) {
  const e = u.tokens;
  if (u.md.options.linkify)
    for (let r = 0, c = e.length; r < c; r++) {
      if (e[r].type !== "inline" || !u.md.linkify.pretest(e[r].content))
        continue;
      let n = e[r].children, t = 0;
      for (let o = n.length - 1; o >= 0; o--) {
        const i = n[o];
        if (i.type === "link_close") {
          for (o--; n[o].level !== i.level && n[o].type !== "link_open"; )
            o--;
          continue;
        }
        if (i.type === "html_inline" && (Ee(i.content) && t > 0 && t--, Fe(i.content) && t++), !(t > 0) && i.type === "text" && u.md.linkify.test(i.content)) {
          const a = i.content;
          let s = u.md.linkify.match(a);
          const f = [];
          let d = i.level, b = 0;
          s.length > 0 && s[0].index === 0 && o > 0 && n[o - 1].type === "text_special" && (s = s.slice(1));
          for (let h = 0; h < s.length; h++) {
            const l = s[h].url, k = u.md.normalizeLink(l);
            if (!u.md.validateLink(k))
              continue;
            let g = s[h].text;
            s[h].schema ? s[h].schema === "mailto:" && !/^mailto:/i.test(g) ? g = u.md.normalizeLinkText("mailto:" + g).replace(/^mailto:/, "") : g = u.md.normalizeLinkText(g) : g = u.md.normalizeLinkText("http://" + g).replace(/^http:\/\//, "");
            const C = s[h].index;
            if (C > b) {
              const m = new u.Token("text", "", 0);
              m.content = a.slice(b, C), m.level = d, f.push(m);
            }
            const p = new u.Token("link_open", "a", 1);
            p.attrs = [["href", k]], p.level = d++, p.markup = "linkify", p.info = "auto", f.push(p);
            const _ = new u.Token("text", "", 0);
            _.content = g, _.level = d, f.push(_);
            const x = new u.Token("link_close", "a", -1);
            x.level = --d, x.markup = "linkify", x.info = "auto", f.push(x), b = s[h].lastIndex;
          }
          if (b < a.length) {
            const h = new u.Token("text", "", 0);
            h.content = a.slice(b), h.level = d, f.push(h);
          }
          e[r].children = n = u0(n, o, f);
        }
      }
    }
}
const n0 = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/, ye = /\((c|tm|r)\)/i, we = /\((c|tm|r)\)/ig, Se = {
  c: "©",
  r: "®",
  tm: "™"
};
function ve(u, e) {
  return Se[e.toLowerCase()];
}
function Be(u) {
  let e = 0;
  for (let r = u.length - 1; r >= 0; r--) {
    const c = u[r];
    c.type === "text" && !e && (c.content = c.content.replace(we, ve)), c.type === "link_open" && c.info === "auto" && e--, c.type === "link_close" && c.info === "auto" && e++;
  }
}
function Te(u) {
  let e = 0;
  for (let r = u.length - 1; r >= 0; r--) {
    const c = u[r];
    c.type === "text" && !e && n0.test(c.content) && (c.content = c.content.replace(/\+-/g, "±").replace(/\.{2,}/g, "…").replace(/([?!])…/g, "$1..").replace(/([?!]){4,}/g, "$1$1$1").replace(/,{2,}/g, ",").replace(/(^|[^-])---(?=[^-]|$)/mg, "$1—").replace(/(^|\s)--(?=\s|$)/mg, "$1–").replace(/(^|[^-\s])--(?=[^-\s]|$)/mg, "$1–")), c.type === "link_open" && c.info === "auto" && e--, c.type === "link_close" && c.info === "auto" && e++;
  }
}
function ze(u) {
  let e;
  if (u.md.options.typographer)
    for (e = u.tokens.length - 1; e >= 0; e--)
      u.tokens[e].type === "inline" && (ye.test(u.tokens[e].content) && Be(u.tokens[e].children), n0.test(u.tokens[e].content) && Te(u.tokens[e].children));
}
const Ie = /['"]/, Lu = /['"]/g, Pu = "’";
function eu(u, e, r) {
  return u.slice(0, e) + r + u.slice(e + 1);
}
function Me(u, e) {
  let r;
  const c = [];
  for (let n = 0; n < u.length; n++) {
    const t = u[n], o = u[n].level;
    for (r = c.length - 1; r >= 0 && !(c[r].level <= o); r--)
      ;
    if (c.length = r + 1, t.type !== "text")
      continue;
    let i = t.content, a = 0, s = i.length;
    u:
      for (; a < s; ) {
        Lu.lastIndex = a;
        const f = Lu.exec(i);
        if (!f)
          break;
        let d = !0, b = !0;
        a = f.index + 1;
        const h = f[0] === "'";
        let l = 32;
        if (f.index - 1 >= 0)
          l = i.charCodeAt(f.index - 1);
        else
          for (r = n - 1; r >= 0 && !(u[r].type === "softbreak" || u[r].type === "hardbreak"); r--)
            if (u[r].content) {
              l = u[r].content.charCodeAt(u[r].content.length - 1);
              break;
            }
        let k = 32;
        if (a < s)
          k = i.charCodeAt(a);
        else
          for (r = n + 1; r < u.length && !(u[r].type === "softbreak" || u[r].type === "hardbreak"); r++)
            if (u[r].content) {
              k = u[r].content.charCodeAt(0);
              break;
            }
        const g = Q(l) || J(String.fromCharCode(l)), C = Q(k) || J(String.fromCharCode(k)), p = W(l), _ = W(k);
        if (_ ? d = !1 : C && (p || g || (d = !1)), p ? b = !1 : g && (_ || C || (b = !1)), k === 34 && f[0] === '"' && l >= 48 && l <= 57 && (b = d = !1), d && b && (d = g, b = C), !d && !b) {
          h && (t.content = eu(t.content, f.index, Pu));
          continue;
        }
        if (b)
          for (r = c.length - 1; r >= 0; r--) {
            let x = c[r];
            if (c[r].level < o)
              break;
            if (x.single === h && c[r].level === o) {
              x = c[r];
              let m, D;
              h ? (m = e.md.options.quotes[2], D = e.md.options.quotes[3]) : (m = e.md.options.quotes[0], D = e.md.options.quotes[1]), t.content = eu(t.content, f.index, D), u[x.token].content = eu(
                u[x.token].content,
                x.pos,
                m
              ), a += D.length - 1, x.token === n && (a += m.length - 1), i = t.content, s = i.length, c.length = r;
              continue u;
            }
          }
        d ? c.push({
          token: n,
          pos: f.index,
          single: h,
          level: o
        }) : b && h && (t.content = eu(t.content, f.index, Pu));
      }
  }
}
function qe(u) {
  if (u.md.options.typographer)
    for (let e = u.tokens.length - 1; e >= 0; e--)
      u.tokens[e].type !== "inline" || !Ie.test(u.tokens[e].content) || Me(u.tokens[e].children, u);
}
function Re(u) {
  let e, r;
  const c = u.tokens, n = c.length;
  for (let t = 0; t < n; t++) {
    if (c[t].type !== "inline") continue;
    const o = c[t].children, i = o.length;
    for (e = 0; e < i; e++)
      o[e].type === "text_special" && (o[e].type = "text");
    for (e = r = 0; e < i; e++)
      o[e].type === "text" && e + 1 < i && o[e + 1].type === "text" ? o[e + 1].content = o[e].content + o[e + 1].content : (e !== r && (o[r] = o[e]), r++);
    e !== r && (o.length = r);
  }
}
const du = [
  ["normalize", ge],
  ["block", De],
  ["inline", Ce],
  ["linkify", Ae],
  ["replacements", ze],
  ["smartquotes", qe],
  // `text_join` finds `text_special` tokens (for escape sequences)
  // and joins them with the rest of the text
  ["text_join", Re]
];
function yu() {
  this.ruler = new S();
  for (let u = 0; u < du.length; u++)
    this.ruler.push(du[u][0], du[u][1]);
}
yu.prototype.process = function(u) {
  const e = this.ruler.getRules("");
  for (let r = 0, c = e.length; r < c; r++)
    e[r](u);
};
yu.prototype.State = r0;
function q(u, e, r, c) {
  this.src = u, this.md = e, this.env = r, this.tokens = c, this.bMarks = [], this.eMarks = [], this.tShift = [], this.sCount = [], this.bsCount = [], this.blkIndent = 0, this.line = 0, this.lineMax = 0, this.tight = !1, this.ddIndent = -1, this.listIndent = -1, this.parentType = "root", this.level = 0;
  const n = this.src;
  for (let t = 0, o = 0, i = 0, a = 0, s = n.length, f = !1; o < s; o++) {
    const d = n.charCodeAt(o);
    if (!f)
      if (E(d)) {
        i++, d === 9 ? a += 4 - a % 4 : a++;
        continue;
      } else
        f = !0;
    (d === 10 || o === s - 1) && (d !== 10 && o++, this.bMarks.push(t), this.eMarks.push(o), this.tShift.push(i), this.sCount.push(a), this.bsCount.push(0), f = !1, i = 0, a = 0, t = o + 1);
  }
  this.bMarks.push(n.length), this.eMarks.push(n.length), this.tShift.push(0), this.sCount.push(0), this.bsCount.push(0), this.lineMax = this.bMarks.length - 1;
}
q.prototype.push = function(u, e, r) {
  const c = new T(u, e, r);
  return c.block = !0, r < 0 && this.level--, c.level = this.level, r > 0 && this.level++, this.tokens.push(c), c;
};
q.prototype.isEmpty = function(e) {
  return this.bMarks[e] + this.tShift[e] >= this.eMarks[e];
};
q.prototype.skipEmptyLines = function(e) {
  for (let r = this.lineMax; e < r && !(this.bMarks[e] + this.tShift[e] < this.eMarks[e]); e++)
    ;
  return e;
};
q.prototype.skipSpaces = function(e) {
  for (let r = this.src.length; e < r; e++) {
    const c = this.src.charCodeAt(e);
    if (!E(c))
      break;
  }
  return e;
};
q.prototype.skipSpacesBack = function(e, r) {
  if (e <= r)
    return e;
  for (; e > r; )
    if (!E(this.src.charCodeAt(--e)))
      return e + 1;
  return e;
};
q.prototype.skipChars = function(e, r) {
  for (let c = this.src.length; e < c && this.src.charCodeAt(e) === r; e++)
    ;
  return e;
};
q.prototype.skipCharsBack = function(e, r, c) {
  if (e <= c)
    return e;
  for (; e > c; )
    if (r !== this.src.charCodeAt(--e))
      return e + 1;
  return e;
};
q.prototype.getLines = function(e, r, c, n) {
  if (e >= r)
    return "";
  const t = new Array(r - e);
  for (let o = 0, i = e; i < r; i++, o++) {
    let a = 0;
    const s = this.bMarks[i];
    let f = s, d;
    for (i + 1 < r || n ? d = this.eMarks[i] + 1 : d = this.eMarks[i]; f < d && a < c; ) {
      const b = this.src.charCodeAt(f);
      if (E(b))
        b === 9 ? a += 4 - (a + this.bsCount[i]) % 4 : a++;
      else if (f - s < this.tShift[i])
        a++;
      else
        break;
      f++;
    }
    a > c ? t[o] = new Array(a - c + 1).join(" ") + this.src.slice(f, d) : t[o] = this.src.slice(f, d);
  }
  return t.join("");
};
q.prototype.Token = T;
const Le = 65536;
function hu(u, e) {
  const r = u.bMarks[e] + u.tShift[e], c = u.eMarks[e];
  return u.src.slice(r, c);
}
function Ou(u) {
  const e = [], r = u.length;
  let c = 0, n = u.charCodeAt(c), t = !1, o = 0, i = "";
  for (; c < r; )
    n === 124 && (t ? (i += u.substring(o, c - 1), o = c) : (e.push(i + u.substring(o, c)), i = "", o = c + 1)), t = n === 92, c++, n = u.charCodeAt(c);
  return e.push(i + u.substring(o)), e;
}
function Pe(u, e, r, c) {
  if (e + 2 > r)
    return !1;
  let n = e + 1;
  if (u.sCount[n] < u.blkIndent || u.sCount[n] - u.blkIndent >= 4)
    return !1;
  let t = u.bMarks[n] + u.tShift[n];
  if (t >= u.eMarks[n])
    return !1;
  const o = u.src.charCodeAt(t++);
  if (o !== 124 && o !== 45 && o !== 58 || t >= u.eMarks[n])
    return !1;
  const i = u.src.charCodeAt(t++);
  if (i !== 124 && i !== 45 && i !== 58 && !E(i) || o === 45 && E(i))
    return !1;
  for (; t < u.eMarks[n]; ) {
    const x = u.src.charCodeAt(t);
    if (x !== 124 && x !== 45 && x !== 58 && !E(x))
      return !1;
    t++;
  }
  let a = hu(u, e + 1), s = a.split("|");
  const f = [];
  for (let x = 0; x < s.length; x++) {
    const m = s[x].trim();
    if (!m) {
      if (x === 0 || x === s.length - 1)
        continue;
      return !1;
    }
    if (!/^:?-+:?$/.test(m))
      return !1;
    m.charCodeAt(m.length - 1) === 58 ? f.push(m.charCodeAt(0) === 58 ? "center" : "right") : m.charCodeAt(0) === 58 ? f.push("left") : f.push("");
  }
  if (a = hu(u, e).trim(), a.indexOf("|") === -1 || u.sCount[e] - u.blkIndent >= 4)
    return !1;
  s = Ou(a), s.length && s[0] === "" && s.shift(), s.length && s[s.length - 1] === "" && s.pop();
  const d = s.length;
  if (d === 0 || d !== f.length)
    return !1;
  if (c)
    return !0;
  const b = u.parentType;
  u.parentType = "table";
  const h = u.md.block.ruler.getRules("blockquote"), l = u.push("table_open", "table", 1), k = [e, 0];
  l.map = k;
  const g = u.push("thead_open", "thead", 1);
  g.map = [e, e + 1];
  const C = u.push("tr_open", "tr", 1);
  C.map = [e, e + 1];
  for (let x = 0; x < s.length; x++) {
    const m = u.push("th_open", "th", 1);
    f[x] && (m.attrs = [["style", "text-align:" + f[x]]]);
    const D = u.push("inline", "", 0);
    D.content = s[x].trim(), D.children = [], u.push("th_close", "th", -1);
  }
  u.push("tr_close", "tr", -1), u.push("thead_close", "thead", -1);
  let p, _ = 0;
  for (n = e + 2; n < r && !(u.sCount[n] < u.blkIndent); n++) {
    let x = !1;
    for (let D = 0, y = h.length; D < y; D++)
      if (h[D](u, n, r, !0)) {
        x = !0;
        break;
      }
    if (x || (a = hu(u, n).trim(), !a) || u.sCount[n] - u.blkIndent >= 4 || (s = Ou(a), s.length && s[0] === "" && s.shift(), s.length && s[s.length - 1] === "" && s.pop(), _ += d - s.length, _ > Le))
      break;
    if (n === e + 2) {
      const D = u.push("tbody_open", "tbody", 1);
      D.map = p = [e + 2, 0];
    }
    const m = u.push("tr_open", "tr", 1);
    m.map = [n, n + 1];
    for (let D = 0; D < d; D++) {
      const y = u.push("td_open", "td", 1);
      f[D] && (y.attrs = [["style", "text-align:" + f[D]]]);
      const B = u.push("inline", "", 0);
      B.content = s[D] ? s[D].trim() : "", B.children = [], u.push("td_close", "td", -1);
    }
    u.push("tr_close", "tr", -1);
  }
  return p && (u.push("tbody_close", "tbody", -1), p[1] = n), u.push("table_close", "table", -1), k[1] = n, u.parentType = b, u.line = n, !0;
}
function Oe(u, e, r) {
  if (u.sCount[e] - u.blkIndent < 4)
    return !1;
  let c = e + 1, n = c;
  for (; c < r; ) {
    if (u.isEmpty(c)) {
      c++;
      continue;
    }
    if (u.sCount[c] - u.blkIndent >= 4) {
      c++, n = c;
      continue;
    }
    break;
  }
  u.line = n;
  const t = u.push("code_block", "code", 0);
  return t.content = u.getLines(e, n, 4 + u.blkIndent, !1) + `
`, t.map = [e, u.line], !0;
}
function Ne(u, e, r, c) {
  let n = u.bMarks[e] + u.tShift[e], t = u.eMarks[e];
  if (u.sCount[e] - u.blkIndent >= 4 || n + 3 > t)
    return !1;
  const o = u.src.charCodeAt(n);
  if (o !== 126 && o !== 96)
    return !1;
  let i = n;
  n = u.skipChars(n, o);
  let a = n - i;
  if (a < 3)
    return !1;
  const s = u.src.slice(i, n), f = u.src.slice(n, t);
  if (o === 96 && f.indexOf(String.fromCharCode(o)) >= 0)
    return !1;
  if (c)
    return !0;
  let d = e, b = !1;
  for (; d++, !(d >= r || (n = i = u.bMarks[d] + u.tShift[d], t = u.eMarks[d], n < t && u.sCount[d] < u.blkIndent)); )
    if (u.src.charCodeAt(n) === o && !(u.sCount[d] - u.blkIndent >= 4) && (n = u.skipChars(n, o), !(n - i < a) && (n = u.skipSpaces(n), !(n < t)))) {
      b = !0;
      break;
    }
  a = u.sCount[e], u.line = d + (b ? 1 : 0);
  const h = u.push("fence", "code", 0);
  return h.info = f, h.content = u.getLines(e + 1, d, a, !0), h.markup = s, h.map = [e, u.line], !0;
}
function je(u, e, r, c) {
  let n = u.bMarks[e] + u.tShift[e], t = u.eMarks[e];
  const o = u.lineMax;
  if (u.sCount[e] - u.blkIndent >= 4 || u.src.charCodeAt(n) !== 62)
    return !1;
  if (c)
    return !0;
  const i = [], a = [], s = [], f = [], d = u.md.block.ruler.getRules("blockquote"), b = u.parentType;
  u.parentType = "blockquote";
  let h = !1, l;
  for (l = e; l < r; l++) {
    const _ = u.sCount[l] < u.blkIndent;
    if (n = u.bMarks[l] + u.tShift[l], t = u.eMarks[l], n >= t)
      break;
    if (u.src.charCodeAt(n++) === 62 && !_) {
      let m = u.sCount[l] + 1, D, y;
      u.src.charCodeAt(n) === 32 ? (n++, m++, y = !1, D = !0) : u.src.charCodeAt(n) === 9 ? (D = !0, (u.bsCount[l] + m) % 4 === 3 ? (n++, m++, y = !1) : y = !0) : D = !1;
      let B = m;
      for (i.push(u.bMarks[l]), u.bMarks[l] = n; n < t; ) {
        const R = u.src.charCodeAt(n);
        if (E(R))
          R === 9 ? B += 4 - (B + u.bsCount[l] + (y ? 1 : 0)) % 4 : B++;
        else
          break;
        n++;
      }
      h = n >= t, a.push(u.bsCount[l]), u.bsCount[l] = u.sCount[l] + 1 + (D ? 1 : 0), s.push(u.sCount[l]), u.sCount[l] = B - m, f.push(u.tShift[l]), u.tShift[l] = n - u.bMarks[l];
      continue;
    }
    if (h)
      break;
    let x = !1;
    for (let m = 0, D = d.length; m < D; m++)
      if (d[m](u, l, r, !0)) {
        x = !0;
        break;
      }
    if (x) {
      u.lineMax = l, u.blkIndent !== 0 && (i.push(u.bMarks[l]), a.push(u.bsCount[l]), f.push(u.tShift[l]), s.push(u.sCount[l]), u.sCount[l] -= u.blkIndent);
      break;
    }
    i.push(u.bMarks[l]), a.push(u.bsCount[l]), f.push(u.tShift[l]), s.push(u.sCount[l]), u.sCount[l] = -1;
  }
  const k = u.blkIndent;
  u.blkIndent = 0;
  const g = u.push("blockquote_open", "blockquote", 1);
  g.markup = ">";
  const C = [e, 0];
  g.map = C, u.md.block.tokenize(u, e, l);
  const p = u.push("blockquote_close", "blockquote", -1);
  p.markup = ">", u.lineMax = o, u.parentType = b, C[1] = u.line;
  for (let _ = 0; _ < f.length; _++)
    u.bMarks[_ + e] = i[_], u.tShift[_ + e] = f[_], u.sCount[_ + e] = s[_], u.bsCount[_ + e] = a[_];
  return u.blkIndent = k, !0;
}
function $e(u, e, r, c) {
  const n = u.eMarks[e];
  if (u.sCount[e] - u.blkIndent >= 4)
    return !1;
  let t = u.bMarks[e] + u.tShift[e];
  const o = u.src.charCodeAt(t++);
  if (o !== 42 && o !== 45 && o !== 95)
    return !1;
  let i = 1;
  for (; t < n; ) {
    const s = u.src.charCodeAt(t++);
    if (s !== o && !E(s))
      return !1;
    s === o && i++;
  }
  if (i < 3)
    return !1;
  if (c)
    return !0;
  u.line = e + 1;
  const a = u.push("hr", "hr", 0);
  return a.map = [e, u.line], a.markup = Array(i + 1).join(String.fromCharCode(o)), !0;
}
function Nu(u, e) {
  const r = u.eMarks[e];
  let c = u.bMarks[e] + u.tShift[e];
  const n = u.src.charCodeAt(c++);
  if (n !== 42 && n !== 45 && n !== 43)
    return -1;
  if (c < r) {
    const t = u.src.charCodeAt(c);
    if (!E(t))
      return -1;
  }
  return c;
}
function ju(u, e) {
  const r = u.bMarks[e] + u.tShift[e], c = u.eMarks[e];
  let n = r;
  if (n + 1 >= c)
    return -1;
  let t = u.src.charCodeAt(n++);
  if (t < 48 || t > 57)
    return -1;
  for (; ; ) {
    if (n >= c)
      return -1;
    if (t = u.src.charCodeAt(n++), t >= 48 && t <= 57) {
      if (n - r >= 10)
        return -1;
      continue;
    }
    if (t === 41 || t === 46)
      break;
    return -1;
  }
  return n < c && (t = u.src.charCodeAt(n), !E(t)) ? -1 : n;
}
function Ue(u, e) {
  const r = u.level + 2;
  for (let c = e + 2, n = u.tokens.length - 2; c < n; c++)
    u.tokens[c].level === r && u.tokens[c].type === "paragraph_open" && (u.tokens[c + 2].hidden = !0, u.tokens[c].hidden = !0, c += 2);
}
function Ze(u, e, r, c) {
  let n, t, o, i, a = e, s = !0;
  if (u.sCount[a] - u.blkIndent >= 4 || u.listIndent >= 0 && u.sCount[a] - u.listIndent >= 4 && u.sCount[a] < u.blkIndent)
    return !1;
  let f = !1;
  c && u.parentType === "paragraph" && u.sCount[a] >= u.blkIndent && (f = !0);
  let d, b, h;
  if ((h = ju(u, a)) >= 0) {
    if (d = !0, o = u.bMarks[a] + u.tShift[a], b = Number(u.src.slice(o, h - 1)), f && b !== 1) return !1;
  } else if ((h = Nu(u, a)) >= 0)
    d = !1;
  else
    return !1;
  if (f && u.skipSpaces(h) >= u.eMarks[a])
    return !1;
  if (c)
    return !0;
  const l = u.src.charCodeAt(h - 1), k = u.tokens.length;
  d ? (i = u.push("ordered_list_open", "ol", 1), b !== 1 && (i.attrs = [["start", b]])) : i = u.push("bullet_list_open", "ul", 1);
  const g = [a, 0];
  i.map = g, i.markup = String.fromCharCode(l);
  let C = !1;
  const p = u.md.block.ruler.getRules("list"), _ = u.parentType;
  for (u.parentType = "list"; a < r; ) {
    t = h, n = u.eMarks[a];
    const x = u.sCount[a] + h - (u.bMarks[a] + u.tShift[a]);
    let m = x;
    for (; t < n; ) {
      const j = u.src.charCodeAt(t);
      if (j === 9)
        m += 4 - (m + u.bsCount[a]) % 4;
      else if (j === 32)
        m++;
      else
        break;
      t++;
    }
    const D = t;
    let y;
    D >= n ? y = 1 : y = m - x, y > 4 && (y = 1);
    const B = x + y;
    i = u.push("list_item_open", "li", 1), i.markup = String.fromCharCode(l);
    const R = [a, 0];
    i.map = R, d && (i.info = u.src.slice(o, h - 1));
    const G = u.tight, fu = u.tShift[a], k0 = u.sCount[a], g0 = u.listIndent;
    if (u.listIndent = u.blkIndent, u.blkIndent = B, u.tight = !0, u.tShift[a] = D - u.bMarks[a], u.sCount[a] = m, D >= n && u.isEmpty(a + 1) ? u.line = Math.min(u.line + 2, r) : u.md.block.tokenize(u, a, r, !0), (!u.tight || C) && (s = !1), C = u.line - a > 1 && u.isEmpty(u.line - 1), u.blkIndent = u.listIndent, u.listIndent = g0, u.tShift[a] = fu, u.sCount[a] = k0, u.tight = G, i = u.push("list_item_close", "li", -1), i.markup = String.fromCharCode(l), a = u.line, R[1] = a, a >= r || u.sCount[a] < u.blkIndent || u.sCount[a] - u.blkIndent >= 4)
      break;
    let vu = !1;
    for (let j = 0, D0 = p.length; j < D0; j++)
      if (p[j](u, a, r, !0)) {
        vu = !0;
        break;
      }
    if (vu)
      break;
    if (d) {
      if (h = ju(u, a), h < 0)
        break;
      o = u.bMarks[a] + u.tShift[a];
    } else if (h = Nu(u, a), h < 0)
      break;
    if (l !== u.src.charCodeAt(h - 1))
      break;
  }
  return d ? i = u.push("ordered_list_close", "ol", -1) : i = u.push("bullet_list_close", "ul", -1), i.markup = String.fromCharCode(l), g[1] = a, u.line = a, u.parentType = _, s && Ue(u, k), !0;
}
function He(u, e, r, c) {
  let n = u.bMarks[e] + u.tShift[e], t = u.eMarks[e], o = e + 1;
  if (u.sCount[e] - u.blkIndent >= 4 || u.src.charCodeAt(n) !== 91)
    return !1;
  function i(p) {
    const _ = u.lineMax;
    if (p >= _ || u.isEmpty(p))
      return null;
    let x = !1;
    if (u.sCount[p] - u.blkIndent > 3 && (x = !0), u.sCount[p] < 0 && (x = !0), !x) {
      const y = u.md.block.ruler.getRules("reference"), B = u.parentType;
      u.parentType = "reference";
      let R = !1;
      for (let G = 0, fu = y.length; G < fu; G++)
        if (y[G](u, p, _, !0)) {
          R = !0;
          break;
        }
      if (u.parentType = B, R)
        return null;
    }
    const m = u.bMarks[p] + u.tShift[p], D = u.eMarks[p];
    return u.src.slice(m, D + 1);
  }
  let a = u.src.slice(n, t + 1);
  t = a.length;
  let s = -1;
  for (n = 1; n < t; n++) {
    const p = a.charCodeAt(n);
    if (p === 91)
      return !1;
    if (p === 93) {
      s = n;
      break;
    } else if (p === 10) {
      const _ = i(o);
      _ !== null && (a += _, t = a.length, o++);
    } else if (p === 92 && (n++, n < t && a.charCodeAt(n) === 10)) {
      const _ = i(o);
      _ !== null && (a += _, t = a.length, o++);
    }
  }
  if (s < 0 || a.charCodeAt(s + 1) !== 58)
    return !1;
  for (n = s + 2; n < t; n++) {
    const p = a.charCodeAt(n);
    if (p === 10) {
      const _ = i(o);
      _ !== null && (a += _, t = a.length, o++);
    } else if (!E(p)) break;
  }
  const f = u.md.helpers.parseLinkDestination(a, n, t);
  if (!f.ok)
    return !1;
  const d = u.md.normalizeLink(f.str);
  if (!u.md.validateLink(d))
    return !1;
  n = f.pos;
  const b = n, h = o, l = n;
  for (; n < t; n++) {
    const p = a.charCodeAt(n);
    if (p === 10) {
      const _ = i(o);
      _ !== null && (a += _, t = a.length, o++);
    } else if (!E(p)) break;
  }
  let k = u.md.helpers.parseLinkTitle(a, n, t);
  for (; k.can_continue; ) {
    const p = i(o);
    if (p === null) break;
    a += p, n = t, t = a.length, o++, k = u.md.helpers.parseLinkTitle(a, n, t, k);
  }
  let g;
  for (n < t && l !== n && k.ok ? (g = k.str, n = k.pos) : (g = "", n = b, o = h); n < t; ) {
    const p = a.charCodeAt(n);
    if (!E(p))
      break;
    n++;
  }
  if (n < t && a.charCodeAt(n) !== 10 && g)
    for (g = "", n = b, o = h; n < t; ) {
      const p = a.charCodeAt(n);
      if (!E(p))
        break;
      n++;
    }
  if (n < t && a.charCodeAt(n) !== 10)
    return !1;
  const C = ou(a.slice(1, s));
  return C ? (c || (typeof u.env.references > "u" && (u.env.references = {}), typeof u.env.references[C] > "u" && (u.env.references[C] = { title: g, href: d }), u.line = o), !0) : !1;
}
const Ve = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], Ge = "[a-zA-Z_:][a-zA-Z0-9:._-]*", We = "[^\"'=<>`\\x00-\\x20]+", Je = "'[^']*'", Qe = '"[^"]*"', Xe = "(?:" + We + "|" + Je + "|" + Qe + ")", Ye = "(?:\\s+" + Ge + "(?:\\s*=\\s*" + Xe + ")?)", t0 = "<[A-Za-z][A-Za-z0-9\\-]*" + Ye + "*\\s*\\/?>", c0 = "<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>", Ke = "<!---?>|<!--(?:[^-]|-[^-]|--[^>])*-->", ur = "<[?][\\s\\S]*?[?]>", er = "<![A-Za-z][^>]*>", rr = "<!\\[CDATA\\[[\\s\\S]*?\\]\\]>", nr = new RegExp("^(?:" + t0 + "|" + c0 + "|" + Ke + "|" + ur + "|" + er + "|" + rr + ")"), tr = new RegExp("^(?:" + t0 + "|" + c0 + ")"), $ = [
  [/^<(script|pre|style|textarea)(?=(\s|>|$))/i, /<\/(script|pre|style|textarea)>/i, !0],
  [/^<!--/, /-->/, !0],
  [/^<\?/, /\?>/, !0],
  [/^<![A-Z]/, />/, !0],
  [/^<!\[CDATA\[/, /\]\]>/, !0],
  [new RegExp("^</?(" + Ve.join("|") + ")(?=(\\s|/?>|$))", "i"), /^$/, !0],
  [new RegExp(tr.source + "\\s*$"), /^$/, !1]
];
function cr(u, e, r, c) {
  let n = u.bMarks[e] + u.tShift[e], t = u.eMarks[e];
  if (u.sCount[e] - u.blkIndent >= 4 || !u.md.options.html || u.src.charCodeAt(n) !== 60)
    return !1;
  let o = u.src.slice(n, t), i = 0;
  for (; i < $.length && !$[i][0].test(o); i++)
    ;
  if (i === $.length)
    return !1;
  if (c)
    return $[i][2];
  let a = e + 1;
  if (!$[i][1].test(o)) {
    for (; a < r && !(u.sCount[a] < u.blkIndent); a++)
      if (n = u.bMarks[a] + u.tShift[a], t = u.eMarks[a], o = u.src.slice(n, t), $[i][1].test(o)) {
        o.length !== 0 && a++;
        break;
      }
  }
  u.line = a;
  const s = u.push("html_block", "", 0);
  return s.map = [e, a], s.content = u.getLines(e, a, u.blkIndent, !0), !0;
}
function ir(u, e, r, c) {
  let n = u.bMarks[e] + u.tShift[e], t = u.eMarks[e];
  if (u.sCount[e] - u.blkIndent >= 4)
    return !1;
  let o = u.src.charCodeAt(n);
  if (o !== 35 || n >= t)
    return !1;
  let i = 1;
  for (o = u.src.charCodeAt(++n); o === 35 && n < t && i <= 6; )
    i++, o = u.src.charCodeAt(++n);
  if (i > 6 || n < t && !E(o))
    return !1;
  if (c)
    return !0;
  t = u.skipSpacesBack(t, n);
  const a = u.skipCharsBack(t, 35, n);
  a > n && E(u.src.charCodeAt(a - 1)) && (t = a), u.line = e + 1;
  const s = u.push("heading_open", "h" + String(i), 1);
  s.markup = "########".slice(0, i), s.map = [e, u.line];
  const f = u.push("inline", "", 0);
  f.content = u.src.slice(n, t).trim(), f.map = [e, u.line], f.children = [];
  const d = u.push("heading_close", "h" + String(i), -1);
  return d.markup = "########".slice(0, i), !0;
}
function or(u, e, r) {
  const c = u.md.block.ruler.getRules("paragraph");
  if (u.sCount[e] - u.blkIndent >= 4)
    return !1;
  const n = u.parentType;
  u.parentType = "paragraph";
  let t = 0, o, i = e + 1;
  for (; i < r && !u.isEmpty(i); i++) {
    if (u.sCount[i] - u.blkIndent > 3)
      continue;
    if (u.sCount[i] >= u.blkIndent) {
      let h = u.bMarks[i] + u.tShift[i];
      const l = u.eMarks[i];
      if (h < l && (o = u.src.charCodeAt(h), (o === 45 || o === 61) && (h = u.skipChars(h, o), h = u.skipSpaces(h), h >= l))) {
        t = o === 61 ? 1 : 2;
        break;
      }
    }
    if (u.sCount[i] < 0)
      continue;
    let b = !1;
    for (let h = 0, l = c.length; h < l; h++)
      if (c[h](u, i, r, !0)) {
        b = !0;
        break;
      }
    if (b)
      break;
  }
  if (!t)
    return !1;
  const a = u.getLines(e, i, u.blkIndent, !1).trim();
  u.line = i + 1;
  const s = u.push("heading_open", "h" + String(t), 1);
  s.markup = String.fromCharCode(o), s.map = [e, u.line];
  const f = u.push("inline", "", 0);
  f.content = a, f.map = [e, u.line - 1], f.children = [];
  const d = u.push("heading_close", "h" + String(t), -1);
  return d.markup = String.fromCharCode(o), u.parentType = n, !0;
}
function ar(u, e, r) {
  const c = u.md.block.ruler.getRules("paragraph"), n = u.parentType;
  let t = e + 1;
  for (u.parentType = "paragraph"; t < r && !u.isEmpty(t); t++) {
    if (u.sCount[t] - u.blkIndent > 3 || u.sCount[t] < 0)
      continue;
    let s = !1;
    for (let f = 0, d = c.length; f < d; f++)
      if (c[f](u, t, r, !0)) {
        s = !0;
        break;
      }
    if (s)
      break;
  }
  const o = u.getLines(e, t, u.blkIndent, !1).trim();
  u.line = t;
  const i = u.push("paragraph_open", "p", 1);
  i.map = [e, u.line];
  const a = u.push("inline", "", 0);
  return a.content = o, a.map = [e, u.line], a.children = [], u.push("paragraph_close", "p", -1), u.parentType = n, !0;
}
const ru = [
  // First 2 params - rule name & source. Secondary array - list of rules,
  // which can be terminated by this one.
  ["table", Pe, ["paragraph", "reference"]],
  ["code", Oe],
  ["fence", Ne, ["paragraph", "reference", "blockquote", "list"]],
  ["blockquote", je, ["paragraph", "reference", "blockquote", "list"]],
  ["hr", $e, ["paragraph", "reference", "blockquote", "list"]],
  ["list", Ze, ["paragraph", "reference", "blockquote"]],
  ["reference", He],
  ["html_block", cr, ["paragraph", "reference", "blockquote"]],
  ["heading", ir, ["paragraph", "reference", "blockquote"]],
  ["lheading", or],
  ["paragraph", ar]
];
function au() {
  this.ruler = new S();
  for (let u = 0; u < ru.length; u++)
    this.ruler.push(ru[u][0], ru[u][1], { alt: (ru[u][2] || []).slice() });
}
au.prototype.tokenize = function(u, e, r) {
  const c = this.ruler.getRules(""), n = c.length, t = u.md.options.maxNesting;
  let o = e, i = !1;
  for (; o < r && (u.line = o = u.skipEmptyLines(o), !(o >= r || u.sCount[o] < u.blkIndent)); ) {
    if (u.level >= t) {
      u.line = r;
      break;
    }
    const a = u.line;
    let s = !1;
    for (let f = 0; f < n; f++)
      if (s = c[f](u, o, r, !1), s) {
        if (a >= u.line)
          throw new Error("block rule didn't increment state.line");
        break;
      }
    if (!s) throw new Error("none of the block rules matched");
    u.tight = !i, u.isEmpty(u.line - 1) && (i = !0), o = u.line, o < r && u.isEmpty(o) && (i = !0, o++, u.line = o);
  }
};
au.prototype.parse = function(u, e, r, c) {
  if (!u)
    return;
  const n = new this.State(u, e, r, c);
  this.tokenize(n, n.line, n.lineMax);
};
au.prototype.State = q;
function K(u, e, r, c) {
  this.src = u, this.env = r, this.md = e, this.tokens = c, this.tokens_meta = Array(c.length), this.pos = 0, this.posMax = this.src.length, this.level = 0, this.pending = "", this.pendingLevel = 0, this.cache = {}, this.delimiters = [], this._prev_delimiters = [], this.backticks = {}, this.backticksScanned = !1, this.linkLevel = 0;
}
K.prototype.pushPending = function() {
  const u = new T("text", "", 0);
  return u.content = this.pending, u.level = this.pendingLevel, this.tokens.push(u), this.pending = "", u;
};
K.prototype.push = function(u, e, r) {
  this.pending && this.pushPending();
  const c = new T(u, e, r);
  let n = null;
  return r < 0 && (this.level--, this.delimiters = this._prev_delimiters.pop()), c.level = this.level, r > 0 && (this.level++, this._prev_delimiters.push(this.delimiters), this.delimiters = [], n = { delimiters: this.delimiters }), this.pendingLevel = this.level, this.tokens.push(c), this.tokens_meta.push(n), c;
};
K.prototype.scanDelims = function(u, e) {
  const r = this.posMax, c = this.src.charCodeAt(u), n = u > 0 ? this.src.charCodeAt(u - 1) : 32;
  let t = u;
  for (; t < r && this.src.charCodeAt(t) === c; )
    t++;
  const o = t - u, i = t < r ? this.src.charCodeAt(t) : 32, a = Q(n) || J(String.fromCharCode(n)), s = Q(i) || J(String.fromCharCode(i)), f = W(n), d = W(i), b = !d && (!s || f || a), h = !f && (!a || d || s);
  return { can_open: b && (e || !h || a), can_close: h && (e || !b || s), length: o };
};
K.prototype.Token = T;
function sr(u) {
  switch (u) {
    case 10:
    case 33:
    case 35:
    case 36:
    case 37:
    case 38:
    case 42:
    case 43:
    case 45:
    case 58:
    case 60:
    case 61:
    case 62:
    case 64:
    case 91:
    case 92:
    case 93:
    case 94:
    case 95:
    case 96:
    case 123:
    case 125:
    case 126:
      return !0;
    default:
      return !1;
  }
}
function fr(u, e) {
  let r = u.pos;
  for (; r < u.posMax && !sr(u.src.charCodeAt(r)); )
    r++;
  return r === u.pos ? !1 : (e || (u.pending += u.src.slice(u.pos, r)), u.pos = r, !0);
}
const lr = /(?:^|[^a-z0-9.+-])([a-z][a-z0-9.+-]*)$/i;
function dr(u, e) {
  if (!u.md.options.linkify || u.linkLevel > 0) return !1;
  const r = u.pos, c = u.posMax;
  if (r + 3 > c || u.src.charCodeAt(r) !== 58 || u.src.charCodeAt(r + 1) !== 47 || u.src.charCodeAt(r + 2) !== 47) return !1;
  const n = u.pending.match(lr);
  if (!n) return !1;
  const t = n[1], o = u.md.linkify.matchAtStart(u.src.slice(r - t.length));
  if (!o) return !1;
  let i = o.url;
  if (i.length <= t.length) return !1;
  i = i.replace(/\*+$/, "");
  const a = u.md.normalizeLink(i);
  if (!u.md.validateLink(a)) return !1;
  if (!e) {
    u.pending = u.pending.slice(0, -t.length);
    const s = u.push("link_open", "a", 1);
    s.attrs = [["href", a]], s.markup = "linkify", s.info = "auto";
    const f = u.push("text", "", 0);
    f.content = u.md.normalizeLinkText(i);
    const d = u.push("link_close", "a", -1);
    d.markup = "linkify", d.info = "auto";
  }
  return u.pos += i.length - t.length, !0;
}
function hr(u, e) {
  let r = u.pos;
  if (u.src.charCodeAt(r) !== 10)
    return !1;
  const c = u.pending.length - 1, n = u.posMax;
  if (!e)
    if (c >= 0 && u.pending.charCodeAt(c) === 32)
      if (c >= 1 && u.pending.charCodeAt(c - 1) === 32) {
        let t = c - 1;
        for (; t >= 1 && u.pending.charCodeAt(t - 1) === 32; ) t--;
        u.pending = u.pending.slice(0, t), u.push("hardbreak", "br", 0);
      } else
        u.pending = u.pending.slice(0, -1), u.push("softbreak", "br", 0);
    else
      u.push("softbreak", "br", 0);
  for (r++; r < n && E(u.src.charCodeAt(r)); )
    r++;
  return u.pos = r, !0;
}
const wu = [];
for (let u = 0; u < 256; u++)
  wu.push(0);
"\\!\"#$%&'()*+,./:;<=>?@[]^_`{|}~-".split("").forEach(function(u) {
  wu[u.charCodeAt(0)] = 1;
});
function br(u, e) {
  let r = u.pos;
  const c = u.posMax;
  if (u.src.charCodeAt(r) !== 92 || (r++, r >= c)) return !1;
  let n = u.src.charCodeAt(r);
  if (n === 10) {
    for (e || u.push("hardbreak", "br", 0), r++; r < c && (n = u.src.charCodeAt(r), !!E(n)); )
      r++;
    return u.pos = r, !0;
  }
  let t = u.src[r];
  if (n >= 55296 && n <= 56319 && r + 1 < c) {
    const i = u.src.charCodeAt(r + 1);
    i >= 56320 && i <= 57343 && (t += u.src[r + 1], r++);
  }
  const o = "\\" + t;
  if (!e) {
    const i = u.push("text_special", "", 0);
    n < 256 && wu[n] !== 0 ? i.content = t : i.content = o, i.markup = o, i.info = "escape";
  }
  return u.pos = r + 1, !0;
}
function pr(u, e) {
  let r = u.pos;
  if (u.src.charCodeAt(r) !== 96)
    return !1;
  const n = r;
  r++;
  const t = u.posMax;
  for (; r < t && u.src.charCodeAt(r) === 96; )
    r++;
  const o = u.src.slice(n, r), i = o.length;
  if (u.backticksScanned && (u.backticks[i] || 0) <= n)
    return e || (u.pending += o), u.pos += i, !0;
  let a = r, s;
  for (; (s = u.src.indexOf("`", a)) !== -1; ) {
    for (a = s + 1; a < t && u.src.charCodeAt(a) === 96; )
      a++;
    const f = a - s;
    if (f === i) {
      if (!e) {
        const d = u.push("code_inline", "code", 0);
        d.markup = o, d.content = u.src.slice(r, s).replace(/\n/g, " ").replace(/^ (.+) $/, "$1");
      }
      return u.pos = a, !0;
    }
    u.backticks[f] = s;
  }
  return u.backticksScanned = !0, e || (u.pending += o), u.pos += i, !0;
}
function xr(u, e) {
  const r = u.pos, c = u.src.charCodeAt(r);
  if (e || c !== 126)
    return !1;
  const n = u.scanDelims(u.pos, !0);
  let t = n.length;
  const o = String.fromCharCode(c);
  if (t < 2)
    return !1;
  let i;
  t % 2 && (i = u.push("text", "", 0), i.content = o, t--);
  for (let a = 0; a < t; a += 2)
    i = u.push("text", "", 0), i.content = o + o, u.delimiters.push({
      marker: c,
      length: 0,
      // disable "rule of 3" length checks meant for emphasis
      token: u.tokens.length - 1,
      end: -1,
      open: n.can_open,
      close: n.can_close
    });
  return u.pos += n.length, !0;
}
function $u(u, e) {
  let r;
  const c = [], n = e.length;
  for (let t = 0; t < n; t++) {
    const o = e[t];
    if (o.marker !== 126 || o.end === -1)
      continue;
    const i = e[o.end];
    r = u.tokens[o.token], r.type = "s_open", r.tag = "s", r.nesting = 1, r.markup = "~~", r.content = "", r = u.tokens[i.token], r.type = "s_close", r.tag = "s", r.nesting = -1, r.markup = "~~", r.content = "", u.tokens[i.token - 1].type === "text" && u.tokens[i.token - 1].content === "~" && c.push(i.token - 1);
  }
  for (; c.length; ) {
    const t = c.pop();
    let o = t + 1;
    for (; o < u.tokens.length && u.tokens[o].type === "s_close"; )
      o++;
    o--, t !== o && (r = u.tokens[o], u.tokens[o] = u.tokens[t], u.tokens[t] = r);
  }
}
function _r(u) {
  const e = u.tokens_meta, r = u.tokens_meta.length;
  $u(u, u.delimiters);
  for (let c = 0; c < r; c++)
    e[c] && e[c].delimiters && $u(u, e[c].delimiters);
}
const i0 = {
  tokenize: xr,
  postProcess: _r
};
function mr(u, e) {
  const r = u.pos, c = u.src.charCodeAt(r);
  if (e || c !== 95 && c !== 42)
    return !1;
  const n = u.scanDelims(u.pos, c === 42);
  for (let t = 0; t < n.length; t++) {
    const o = u.push("text", "", 0);
    o.content = String.fromCharCode(c), u.delimiters.push({
      // Char code of the starting marker (number).
      //
      marker: c,
      // Total length of these series of delimiters.
      //
      length: n.length,
      // A position of the token this delimiter corresponds to.
      //
      token: u.tokens.length - 1,
      // If this delimiter is matched as a valid opener, `end` will be
      // equal to its position, otherwise it's `-1`.
      //
      end: -1,
      // Boolean flags that determine if this delimiter could open or close
      // an emphasis.
      //
      open: n.can_open,
      close: n.can_close
    });
  }
  return u.pos += n.length, !0;
}
function Uu(u, e) {
  const r = e.length;
  for (let c = r - 1; c >= 0; c--) {
    const n = e[c];
    if (n.marker !== 95 && n.marker !== 42 || n.end === -1)
      continue;
    const t = e[n.end], o = c > 0 && e[c - 1].end === n.end + 1 && // check that first two markers match and adjacent
    e[c - 1].marker === n.marker && e[c - 1].token === n.token - 1 && // check that last two markers are adjacent (we can safely assume they match)
    e[n.end + 1].token === t.token + 1, i = String.fromCharCode(n.marker), a = u.tokens[n.token];
    a.type = o ? "strong_open" : "em_open", a.tag = o ? "strong" : "em", a.nesting = 1, a.markup = o ? i + i : i, a.content = "";
    const s = u.tokens[t.token];
    s.type = o ? "strong_close" : "em_close", s.tag = o ? "strong" : "em", s.nesting = -1, s.markup = o ? i + i : i, s.content = "", o && (u.tokens[e[c - 1].token].content = "", u.tokens[e[n.end + 1].token].content = "", c--);
  }
}
function kr(u) {
  const e = u.tokens_meta, r = u.tokens_meta.length;
  Uu(u, u.delimiters);
  for (let c = 0; c < r; c++)
    e[c] && e[c].delimiters && Uu(u, e[c].delimiters);
}
const o0 = {
  tokenize: mr,
  postProcess: kr
};
function gr(u, e) {
  let r, c, n, t, o = "", i = "", a = u.pos, s = !0;
  if (u.src.charCodeAt(u.pos) !== 91)
    return !1;
  const f = u.pos, d = u.posMax, b = u.pos + 1, h = u.md.helpers.parseLinkLabel(u, u.pos, !0);
  if (h < 0)
    return !1;
  let l = h + 1;
  if (l < d && u.src.charCodeAt(l) === 40) {
    for (s = !1, l++; l < d && (r = u.src.charCodeAt(l), !(!E(r) && r !== 10)); l++)
      ;
    if (l >= d)
      return !1;
    if (a = l, n = u.md.helpers.parseLinkDestination(u.src, l, u.posMax), n.ok) {
      for (o = u.md.normalizeLink(n.str), u.md.validateLink(o) ? l = n.pos : o = "", a = l; l < d && (r = u.src.charCodeAt(l), !(!E(r) && r !== 10)); l++)
        ;
      if (n = u.md.helpers.parseLinkTitle(u.src, l, u.posMax), l < d && a !== l && n.ok)
        for (i = n.str, l = n.pos; l < d && (r = u.src.charCodeAt(l), !(!E(r) && r !== 10)); l++)
          ;
    }
    (l >= d || u.src.charCodeAt(l) !== 41) && (s = !0), l++;
  }
  if (s) {
    if (typeof u.env.references > "u")
      return !1;
    if (l < d && u.src.charCodeAt(l) === 91 ? (a = l + 1, l = u.md.helpers.parseLinkLabel(u, l), l >= 0 ? c = u.src.slice(a, l++) : l = h + 1) : l = h + 1, c || (c = u.src.slice(b, h)), t = u.env.references[ou(c)], !t)
      return u.pos = f, !1;
    o = t.href, i = t.title;
  }
  if (!e) {
    u.pos = b, u.posMax = h;
    const k = u.push("link_open", "a", 1), g = [["href", o]];
    k.attrs = g, i && g.push(["title", i]), u.linkLevel++, u.md.inline.tokenize(u), u.linkLevel--, u.push("link_close", "a", -1);
  }
  return u.pos = l, u.posMax = d, !0;
}
function Dr(u, e) {
  let r, c, n, t, o, i, a, s, f = "";
  const d = u.pos, b = u.posMax;
  if (u.src.charCodeAt(u.pos) !== 33 || u.src.charCodeAt(u.pos + 1) !== 91)
    return !1;
  const h = u.pos + 2, l = u.md.helpers.parseLinkLabel(u, u.pos + 1, !1);
  if (l < 0)
    return !1;
  if (t = l + 1, t < b && u.src.charCodeAt(t) === 40) {
    for (t++; t < b && (r = u.src.charCodeAt(t), !(!E(r) && r !== 10)); t++)
      ;
    if (t >= b)
      return !1;
    for (s = t, i = u.md.helpers.parseLinkDestination(u.src, t, u.posMax), i.ok && (f = u.md.normalizeLink(i.str), u.md.validateLink(f) ? t = i.pos : f = ""), s = t; t < b && (r = u.src.charCodeAt(t), !(!E(r) && r !== 10)); t++)
      ;
    if (i = u.md.helpers.parseLinkTitle(u.src, t, u.posMax), t < b && s !== t && i.ok)
      for (a = i.str, t = i.pos; t < b && (r = u.src.charCodeAt(t), !(!E(r) && r !== 10)); t++)
        ;
    else
      a = "";
    if (t >= b || u.src.charCodeAt(t) !== 41)
      return u.pos = d, !1;
    t++;
  } else {
    if (typeof u.env.references > "u")
      return !1;
    if (t < b && u.src.charCodeAt(t) === 91 ? (s = t + 1, t = u.md.helpers.parseLinkLabel(u, t), t >= 0 ? n = u.src.slice(s, t++) : t = l + 1) : t = l + 1, n || (n = u.src.slice(h, l)), o = u.env.references[ou(n)], !o)
      return u.pos = d, !1;
    f = o.href, a = o.title;
  }
  if (!e) {
    c = u.src.slice(h, l);
    const k = [];
    u.md.inline.parse(
      c,
      u.md,
      u.env,
      k
    );
    const g = u.push("image", "img", 0), C = [["src", f], ["alt", ""]];
    g.attrs = C, g.children = k, g.content = c, a && C.push(["title", a]);
  }
  return u.pos = t, u.posMax = b, !0;
}
const Cr = /^([a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)$/, Er = /^([a-zA-Z][a-zA-Z0-9+.-]{1,31}):([^<>\x00-\x20]*)$/;
function Fr(u, e) {
  let r = u.pos;
  if (u.src.charCodeAt(r) !== 60)
    return !1;
  const c = u.pos, n = u.posMax;
  for (; ; ) {
    if (++r >= n) return !1;
    const o = u.src.charCodeAt(r);
    if (o === 60) return !1;
    if (o === 62) break;
  }
  const t = u.src.slice(c + 1, r);
  if (Er.test(t)) {
    const o = u.md.normalizeLink(t);
    if (!u.md.validateLink(o))
      return !1;
    if (!e) {
      const i = u.push("link_open", "a", 1);
      i.attrs = [["href", o]], i.markup = "autolink", i.info = "auto";
      const a = u.push("text", "", 0);
      a.content = u.md.normalizeLinkText(t);
      const s = u.push("link_close", "a", -1);
      s.markup = "autolink", s.info = "auto";
    }
    return u.pos += t.length + 2, !0;
  }
  if (Cr.test(t)) {
    const o = u.md.normalizeLink("mailto:" + t);
    if (!u.md.validateLink(o))
      return !1;
    if (!e) {
      const i = u.push("link_open", "a", 1);
      i.attrs = [["href", o]], i.markup = "autolink", i.info = "auto";
      const a = u.push("text", "", 0);
      a.content = u.md.normalizeLinkText(t);
      const s = u.push("link_close", "a", -1);
      s.markup = "autolink", s.info = "auto";
    }
    return u.pos += t.length + 2, !0;
  }
  return !1;
}
function Ar(u) {
  return /^<a[>\s]/i.test(u);
}
function yr(u) {
  return /^<\/a\s*>/i.test(u);
}
function wr(u) {
  const e = u | 32;
  return e >= 97 && e <= 122;
}
function Sr(u, e) {
  if (!u.md.options.html)
    return !1;
  const r = u.posMax, c = u.pos;
  if (u.src.charCodeAt(c) !== 60 || c + 2 >= r)
    return !1;
  const n = u.src.charCodeAt(c + 1);
  if (n !== 33 && n !== 63 && n !== 47 && !wr(n))
    return !1;
  const t = u.src.slice(c).match(nr);
  if (!t)
    return !1;
  if (!e) {
    const o = u.push("html_inline", "", 0);
    o.content = t[0], Ar(o.content) && u.linkLevel++, yr(o.content) && u.linkLevel--;
  }
  return u.pos += t[0].length, !0;
}
const vr = /^&#((?:x[a-f0-9]{1,6}|[0-9]{1,7}));/i, Br = /^&([a-z][a-z0-9]{1,31});/i;
function Tr(u, e) {
  const r = u.pos, c = u.posMax;
  if (u.src.charCodeAt(r) !== 38 || r + 1 >= c) return !1;
  if (u.src.charCodeAt(r + 1) === 35) {
    const t = u.src.slice(r).match(vr);
    if (t) {
      if (!e) {
        const o = t[1][0].toLowerCase() === "x" ? parseInt(t[1].slice(1), 16) : parseInt(t[1], 10), i = u.push("text_special", "", 0);
        i.content = Au(o) ? tu(o) : tu(65533), i.markup = t[0], i.info = "entity";
      }
      return u.pos += t[0].length, !0;
    }
  } else {
    const t = u.src.slice(r).match(Br);
    if (t) {
      const o = Ku(t[0]);
      if (o !== t[0]) {
        if (!e) {
          const i = u.push("text_special", "", 0);
          i.content = o, i.markup = t[0], i.info = "entity";
        }
        return u.pos += t[0].length, !0;
      }
    }
  }
  return !1;
}
function Zu(u) {
  const e = {}, r = u.length;
  if (!r) return;
  let c = 0, n = -2;
  const t = [];
  for (let o = 0; o < r; o++) {
    const i = u[o];
    if (t.push(0), (u[c].marker !== i.marker || n !== i.token - 1) && (c = o), n = i.token, i.length = i.length || 0, !i.close) continue;
    e.hasOwnProperty(i.marker) || (e[i.marker] = [-1, -1, -1, -1, -1, -1]);
    const a = e[i.marker][(i.open ? 3 : 0) + i.length % 3];
    let s = c - t[c] - 1, f = s;
    for (; s > a; s -= t[s] + 1) {
      const d = u[s];
      if (d.marker === i.marker && d.open && d.end < 0) {
        let b = !1;
        if ((d.close || i.open) && (d.length + i.length) % 3 === 0 && (d.length % 3 !== 0 || i.length % 3 !== 0) && (b = !0), !b) {
          const h = s > 0 && !u[s - 1].open ? t[s - 1] + 1 : 0;
          t[o] = o - s + h, t[s] = h, i.open = !1, d.end = o, d.close = !1, f = -1, n = -2;
          break;
        }
      }
    }
    f !== -1 && (e[i.marker][(i.open ? 3 : 0) + (i.length || 0) % 3] = f);
  }
}
function zr(u) {
  const e = u.tokens_meta, r = u.tokens_meta.length;
  Zu(u.delimiters);
  for (let c = 0; c < r; c++)
    e[c] && e[c].delimiters && Zu(e[c].delimiters);
}
function Ir(u) {
  let e, r, c = 0;
  const n = u.tokens, t = u.tokens.length;
  for (e = r = 0; e < t; e++)
    n[e].nesting < 0 && c--, n[e].level = c, n[e].nesting > 0 && c++, n[e].type === "text" && e + 1 < t && n[e + 1].type === "text" ? n[e + 1].content = n[e].content + n[e + 1].content : (e !== r && (n[r] = n[e]), r++);
  e !== r && (n.length = r);
}
const bu = [
  ["text", fr],
  ["linkify", dr],
  ["newline", hr],
  ["escape", br],
  ["backticks", pr],
  ["strikethrough", i0.tokenize],
  ["emphasis", o0.tokenize],
  ["link", gr],
  ["image", Dr],
  ["autolink", Fr],
  ["html_inline", Sr],
  ["entity", Tr]
], pu = [
  ["balance_pairs", zr],
  ["strikethrough", i0.postProcess],
  ["emphasis", o0.postProcess],
  // rules for pairs separate '**' into its own text tokens, which may be left unused,
  // rule below merges unused segments back with the rest of the text
  ["fragments_join", Ir]
];
function uu() {
  this.ruler = new S();
  for (let u = 0; u < bu.length; u++)
    this.ruler.push(bu[u][0], bu[u][1]);
  this.ruler2 = new S();
  for (let u = 0; u < pu.length; u++)
    this.ruler2.push(pu[u][0], pu[u][1]);
}
uu.prototype.skipToken = function(u) {
  const e = u.pos, r = this.ruler.getRules(""), c = r.length, n = u.md.options.maxNesting, t = u.cache;
  if (typeof t[e] < "u") {
    u.pos = t[e];
    return;
  }
  let o = !1;
  if (u.level < n) {
    for (let i = 0; i < c; i++)
      if (u.level++, o = r[i](u, !0), u.level--, o) {
        if (e >= u.pos)
          throw new Error("inline rule didn't increment state.pos");
        break;
      }
  } else
    u.pos = u.posMax;
  o || u.pos++, t[e] = u.pos;
};
uu.prototype.tokenize = function(u) {
  const e = this.ruler.getRules(""), r = e.length, c = u.posMax, n = u.md.options.maxNesting;
  for (; u.pos < c; ) {
    const t = u.pos;
    let o = !1;
    if (u.level < n) {
      for (let i = 0; i < r; i++)
        if (o = e[i](u, !1), o) {
          if (t >= u.pos)
            throw new Error("inline rule didn't increment state.pos");
          break;
        }
    }
    if (o) {
      if (u.pos >= c)
        break;
      continue;
    }
    u.pending += u.src[u.pos++];
  }
  u.pending && u.pushPending();
};
uu.prototype.parse = function(u, e, r, c) {
  const n = new this.State(u, e, r, c);
  this.tokenize(n);
  const t = this.ruler2.getRules(""), o = t.length;
  for (let i = 0; i < o; i++)
    t[i](n);
};
uu.prototype.State = K;
function Mr(u) {
  const e = {};
  u = u || {}, e.src_Any = Wu.source, e.src_Cc = Ju.source, e.src_Z = Xu.source, e.src_P = Eu.source, e.src_ZPCc = [e.src_Z, e.src_P, e.src_Cc].join("|"), e.src_ZCc = [e.src_Z, e.src_Cc].join("|");
  const r = "[><｜]";
  return e.src_pseudo_letter = "(?:(?!" + r + "|" + e.src_ZPCc + ")" + e.src_Any + ")", e.src_ip4 = "(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)", e.src_auth = "(?:(?:(?!" + e.src_ZCc + "|[@/\\[\\]()]).)+@)?", e.src_port = "(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?", e.src_host_terminator = "(?=$|" + r + "|" + e.src_ZPCc + ")(?!" + (u["---"] ? "-(?!--)|" : "-|") + "_|:\\d|\\.-|\\.(?!$|" + e.src_ZPCc + "))", e.src_path = "(?:[/?#](?:(?!" + e.src_ZCc + "|" + r + `|[()[\\]{}.,"'?!\\-;]).|\\[(?:(?!` + e.src_ZCc + "|\\]).)*\\]|\\((?:(?!" + e.src_ZCc + "|[)]).)*\\)|\\{(?:(?!" + e.src_ZCc + '|[}]).)*\\}|\\"(?:(?!' + e.src_ZCc + `|["]).)+\\"|\\'(?:(?!` + e.src_ZCc + "|[']).)+\\'|\\'(?=" + e.src_pseudo_letter + "|[-])|\\.{2,}[a-zA-Z0-9%/&]|\\.(?!" + e.src_ZCc + "|[.]|$)|" + (u["---"] ? "\\-(?!--(?:[^-]|$))(?:-*)|" : "\\-+|") + // allow `,,,` in paths
  ",(?!" + e.src_ZCc + "|$)|;(?!" + e.src_ZCc + "|$)|\\!+(?!" + e.src_ZCc + "|[!]|$)|\\?(?!" + e.src_ZCc + "|[?]|$))+|\\/)?", e.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*', e.src_xn = "xn--[a-z0-9\\-]{1,59}", e.src_domain_root = // Allow letters & digits (http://test1)
  "(?:" + e.src_xn + "|" + e.src_pseudo_letter + "{1,63})", e.src_domain = "(?:" + e.src_xn + "|(?:" + e.src_pseudo_letter + ")|(?:" + e.src_pseudo_letter + "(?:-|" + e.src_pseudo_letter + "){0,61}" + e.src_pseudo_letter + "))", e.src_host = "(?:(?:(?:(?:" + e.src_domain + ")\\.)*" + e.src_domain + "))", e.tpl_host_fuzzy = "(?:" + e.src_ip4 + "|(?:(?:(?:" + e.src_domain + ")\\.)+(?:%TLDS%)))", e.tpl_host_no_ip_fuzzy = "(?:(?:(?:" + e.src_domain + ")\\.)+(?:%TLDS%))", e.src_host_strict = e.src_host + e.src_host_terminator, e.tpl_host_fuzzy_strict = e.tpl_host_fuzzy + e.src_host_terminator, e.src_host_port_strict = e.src_host + e.src_port + e.src_host_terminator, e.tpl_host_port_fuzzy_strict = e.tpl_host_fuzzy + e.src_port + e.src_host_terminator, e.tpl_host_port_no_ip_fuzzy_strict = e.tpl_host_no_ip_fuzzy + e.src_port + e.src_host_terminator, e.tpl_host_fuzzy_test = "localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:" + e.src_ZPCc + "|>|$))", e.tpl_email_fuzzy = "(^|" + r + '|"|\\(|' + e.src_ZCc + ")(" + e.src_email_name + "@" + e.tpl_host_fuzzy_strict + ")", e.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
  // but can start with > (markdown blockquote)
  "(^|(?![.:/\\-_@])(?:[$+<=>^`|｜]|" + e.src_ZPCc + "))((?![$+<=>^`|｜])" + e.tpl_host_port_fuzzy_strict + e.src_path + ")", e.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
  // but can start with > (markdown blockquote)
  "(^|(?![.:/\\-_@])(?:[$+<=>^`|｜]|" + e.src_ZPCc + "))((?![$+<=>^`|｜])" + e.tpl_host_port_no_ip_fuzzy_strict + e.src_path + ")", e;
}
function ku(u) {
  return Array.prototype.slice.call(arguments, 1).forEach(function(r) {
    r && Object.keys(r).forEach(function(c) {
      u[c] = r[c];
    });
  }), u;
}
function su(u) {
  return Object.prototype.toString.call(u);
}
function qr(u) {
  return su(u) === "[object String]";
}
function Rr(u) {
  return su(u) === "[object Object]";
}
function Lr(u) {
  return su(u) === "[object RegExp]";
}
function Hu(u) {
  return su(u) === "[object Function]";
}
function Pr(u) {
  return u.replace(/[.?*+^$[\]\\(){}|-]/g, "\\$&");
}
const a0 = {
  fuzzyLink: !0,
  fuzzyEmail: !0,
  fuzzyIP: !1
};
function Or(u) {
  return Object.keys(u || {}).reduce(function(e, r) {
    return e || a0.hasOwnProperty(r);
  }, !1);
}
const Nr = {
  "http:": {
    validate: function(u, e, r) {
      const c = u.slice(e);
      return r.re.http || (r.re.http = new RegExp(
        "^\\/\\/" + r.re.src_auth + r.re.src_host_port_strict + r.re.src_path,
        "i"
      )), r.re.http.test(c) ? c.match(r.re.http)[0].length : 0;
    }
  },
  "https:": "http:",
  "ftp:": "http:",
  "//": {
    validate: function(u, e, r) {
      const c = u.slice(e);
      return r.re.no_http || (r.re.no_http = new RegExp(
        "^" + r.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
        // with code comments
        "(?:localhost|(?:(?:" + r.re.src_domain + ")\\.)+" + r.re.src_domain_root + ")" + r.re.src_port + r.re.src_host_terminator + r.re.src_path,
        "i"
      )), r.re.no_http.test(c) ? e >= 3 && u[e - 3] === ":" || e >= 3 && u[e - 3] === "/" ? 0 : c.match(r.re.no_http)[0].length : 0;
    }
  },
  "mailto:": {
    validate: function(u, e, r) {
      const c = u.slice(e);
      return r.re.mailto || (r.re.mailto = new RegExp(
        "^" + r.re.src_email_name + "@" + r.re.src_host_strict,
        "i"
      )), r.re.mailto.test(c) ? c.match(r.re.mailto)[0].length : 0;
    }
  }
}, jr = "a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]", $r = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф".split("|");
function Ur(u) {
  u.__index__ = -1, u.__text_cache__ = "";
}
function Zr(u) {
  return function(e, r) {
    const c = e.slice(r);
    return u.test(c) ? c.match(u)[0].length : 0;
  };
}
function Vu() {
  return function(u, e) {
    e.normalize(u);
  };
}
function cu(u) {
  const e = u.re = Mr(u.__opts__), r = u.__tlds__.slice();
  u.onCompile(), u.__tlds_replaced__ || r.push(jr), r.push(e.src_xn), e.src_tlds = r.join("|");
  function c(i) {
    return i.replace("%TLDS%", e.src_tlds);
  }
  e.email_fuzzy = RegExp(c(e.tpl_email_fuzzy), "i"), e.link_fuzzy = RegExp(c(e.tpl_link_fuzzy), "i"), e.link_no_ip_fuzzy = RegExp(c(e.tpl_link_no_ip_fuzzy), "i"), e.host_fuzzy_test = RegExp(c(e.tpl_host_fuzzy_test), "i");
  const n = [];
  u.__compiled__ = {};
  function t(i, a) {
    throw new Error('(LinkifyIt) Invalid schema "' + i + '": ' + a);
  }
  Object.keys(u.__schemas__).forEach(function(i) {
    const a = u.__schemas__[i];
    if (a === null)
      return;
    const s = { validate: null, link: null };
    if (u.__compiled__[i] = s, Rr(a)) {
      Lr(a.validate) ? s.validate = Zr(a.validate) : Hu(a.validate) ? s.validate = a.validate : t(i, a), Hu(a.normalize) ? s.normalize = a.normalize : a.normalize ? t(i, a) : s.normalize = Vu();
      return;
    }
    if (qr(a)) {
      n.push(i);
      return;
    }
    t(i, a);
  }), n.forEach(function(i) {
    u.__compiled__[u.__schemas__[i]] && (u.__compiled__[i].validate = u.__compiled__[u.__schemas__[i]].validate, u.__compiled__[i].normalize = u.__compiled__[u.__schemas__[i]].normalize);
  }), u.__compiled__[""] = { validate: null, normalize: Vu() };
  const o = Object.keys(u.__compiled__).filter(function(i) {
    return i.length > 0 && u.__compiled__[i];
  }).map(Pr).join("|");
  u.re.schema_test = RegExp("(^|(?!_)(?:[><｜]|" + e.src_ZPCc + "))(" + o + ")", "i"), u.re.schema_search = RegExp("(^|(?!_)(?:[><｜]|" + e.src_ZPCc + "))(" + o + ")", "ig"), u.re.schema_at_start = RegExp("^" + u.re.schema_search.source, "i"), u.re.pretest = RegExp(
    "(" + u.re.schema_test.source + ")|(" + u.re.host_fuzzy_test.source + ")|@",
    "i"
  ), Ur(u);
}
function Hr(u, e) {
  const r = u.__index__, c = u.__last_index__, n = u.__text_cache__.slice(r, c);
  this.schema = u.__schema__.toLowerCase(), this.index = r + e, this.lastIndex = c + e, this.raw = n, this.text = n, this.url = n;
}
function gu(u, e) {
  const r = new Hr(u, e);
  return u.__compiled__[r.schema].normalize(r, u), r;
}
function v(u, e) {
  if (!(this instanceof v))
    return new v(u, e);
  e || Or(u) && (e = u, u = {}), this.__opts__ = ku({}, a0, e), this.__index__ = -1, this.__last_index__ = -1, this.__schema__ = "", this.__text_cache__ = "", this.__schemas__ = ku({}, Nr, u), this.__compiled__ = {}, this.__tlds__ = $r, this.__tlds_replaced__ = !1, this.re = {}, cu(this);
}
v.prototype.add = function(e, r) {
  return this.__schemas__[e] = r, cu(this), this;
};
v.prototype.set = function(e) {
  return this.__opts__ = ku(this.__opts__, e), this;
};
v.prototype.test = function(e) {
  if (this.__text_cache__ = e, this.__index__ = -1, !e.length)
    return !1;
  let r, c, n, t, o, i, a, s, f;
  if (this.re.schema_test.test(e)) {
    for (a = this.re.schema_search, a.lastIndex = 0; (r = a.exec(e)) !== null; )
      if (t = this.testSchemaAt(e, r[2], a.lastIndex), t) {
        this.__schema__ = r[2], this.__index__ = r.index + r[1].length, this.__last_index__ = r.index + r[0].length + t;
        break;
      }
  }
  return this.__opts__.fuzzyLink && this.__compiled__["http:"] && (s = e.search(this.re.host_fuzzy_test), s >= 0 && (this.__index__ < 0 || s < this.__index__) && (c = e.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null && (o = c.index + c[1].length, (this.__index__ < 0 || o < this.__index__) && (this.__schema__ = "", this.__index__ = o, this.__last_index__ = c.index + c[0].length))), this.__opts__.fuzzyEmail && this.__compiled__["mailto:"] && (f = e.indexOf("@"), f >= 0 && (n = e.match(this.re.email_fuzzy)) !== null && (o = n.index + n[1].length, i = n.index + n[0].length, (this.__index__ < 0 || o < this.__index__ || o === this.__index__ && i > this.__last_index__) && (this.__schema__ = "mailto:", this.__index__ = o, this.__last_index__ = i))), this.__index__ >= 0;
};
v.prototype.pretest = function(e) {
  return this.re.pretest.test(e);
};
v.prototype.testSchemaAt = function(e, r, c) {
  return this.__compiled__[r.toLowerCase()] ? this.__compiled__[r.toLowerCase()].validate(e, c, this) : 0;
};
v.prototype.match = function(e) {
  const r = [];
  let c = 0;
  this.__index__ >= 0 && this.__text_cache__ === e && (r.push(gu(this, c)), c = this.__last_index__);
  let n = c ? e.slice(c) : e;
  for (; this.test(n); )
    r.push(gu(this, c)), n = n.slice(this.__last_index__), c += this.__last_index__;
  return r.length ? r : null;
};
v.prototype.matchAtStart = function(e) {
  if (this.__text_cache__ = e, this.__index__ = -1, !e.length) return null;
  const r = this.re.schema_at_start.exec(e);
  if (!r) return null;
  const c = this.testSchemaAt(e, r[2], r[0].length);
  return c ? (this.__schema__ = r[2], this.__index__ = r.index + r[1].length, this.__last_index__ = r.index + r[0].length + c, gu(this, 0)) : null;
};
v.prototype.tlds = function(e, r) {
  return e = Array.isArray(e) ? e : [e], r ? (this.__tlds__ = this.__tlds__.concat(e).sort().filter(function(c, n, t) {
    return c !== t[n - 1];
  }).reverse(), cu(this), this) : (this.__tlds__ = e.slice(), this.__tlds_replaced__ = !0, cu(this), this);
};
v.prototype.normalize = function(e) {
  e.schema || (e.url = "http://" + e.url), e.schema === "mailto:" && !/^mailto:/i.test(e.url) && (e.url = "mailto:" + e.url);
};
v.prototype.onCompile = function() {
};
const U = 2147483647, z = 36, Su = 1, X = 26, Vr = 38, Gr = 700, s0 = 72, f0 = 128, l0 = "-", Wr = /^xn--/, Jr = /[^\0-\x7F]/, Qr = /[\x2E\u3002\uFF0E\uFF61]/g, Xr = {
  overflow: "Overflow: input needs wider integers to process",
  "not-basic": "Illegal input >= 0x80 (not a basic code point)",
  "invalid-input": "Invalid input"
}, xu = z - Su, I = Math.floor, _u = String.fromCharCode;
function L(u) {
  throw new RangeError(Xr[u]);
}
function Yr(u, e) {
  const r = [];
  let c = u.length;
  for (; c--; )
    r[c] = e(u[c]);
  return r;
}
function d0(u, e) {
  const r = u.split("@");
  let c = "";
  r.length > 1 && (c = r[0] + "@", u = r[1]), u = u.replace(Qr, ".");
  const n = u.split("."), t = Yr(n, e).join(".");
  return c + t;
}
function h0(u) {
  const e = [];
  let r = 0;
  const c = u.length;
  for (; r < c; ) {
    const n = u.charCodeAt(r++);
    if (n >= 55296 && n <= 56319 && r < c) {
      const t = u.charCodeAt(r++);
      (t & 64512) == 56320 ? e.push(((n & 1023) << 10) + (t & 1023) + 65536) : (e.push(n), r--);
    } else
      e.push(n);
  }
  return e;
}
const Kr = (u) => String.fromCodePoint(...u), un = function(u) {
  return u >= 48 && u < 58 ? 26 + (u - 48) : u >= 65 && u < 91 ? u - 65 : u >= 97 && u < 123 ? u - 97 : z;
}, Gu = function(u, e) {
  return u + 22 + 75 * (u < 26) - ((e != 0) << 5);
}, b0 = function(u, e, r) {
  let c = 0;
  for (u = r ? I(u / Gr) : u >> 1, u += I(u / e); u > xu * X >> 1; c += z)
    u = I(u / xu);
  return I(c + (xu + 1) * u / (u + Vr));
}, p0 = function(u) {
  const e = [], r = u.length;
  let c = 0, n = f0, t = s0, o = u.lastIndexOf(l0);
  o < 0 && (o = 0);
  for (let i = 0; i < o; ++i)
    u.charCodeAt(i) >= 128 && L("not-basic"), e.push(u.charCodeAt(i));
  for (let i = o > 0 ? o + 1 : 0; i < r; ) {
    const a = c;
    for (let f = 1, d = z; ; d += z) {
      i >= r && L("invalid-input");
      const b = un(u.charCodeAt(i++));
      b >= z && L("invalid-input"), b > I((U - c) / f) && L("overflow"), c += b * f;
      const h = d <= t ? Su : d >= t + X ? X : d - t;
      if (b < h)
        break;
      const l = z - h;
      f > I(U / l) && L("overflow"), f *= l;
    }
    const s = e.length + 1;
    t = b0(c - a, s, a == 0), I(c / s) > U - n && L("overflow"), n += I(c / s), c %= s, e.splice(c++, 0, n);
  }
  return String.fromCodePoint(...e);
}, x0 = function(u) {
  const e = [];
  u = h0(u);
  const r = u.length;
  let c = f0, n = 0, t = s0;
  for (const a of u)
    a < 128 && e.push(_u(a));
  const o = e.length;
  let i = o;
  for (o && e.push(l0); i < r; ) {
    let a = U;
    for (const f of u)
      f >= c && f < a && (a = f);
    const s = i + 1;
    a - c > I((U - n) / s) && L("overflow"), n += (a - c) * s, c = a;
    for (const f of u)
      if (f < c && ++n > U && L("overflow"), f === c) {
        let d = n;
        for (let b = z; ; b += z) {
          const h = b <= t ? Su : b >= t + X ? X : b - t;
          if (d < h)
            break;
          const l = d - h, k = z - h;
          e.push(
            _u(Gu(h + l % k, 0))
          ), d = I(l / k);
        }
        e.push(_u(Gu(d, 0))), t = b0(n, s, i === o), n = 0, ++i;
      }
    ++n, ++c;
  }
  return e.join("");
}, en = function(u) {
  return d0(u, function(e) {
    return Wr.test(e) ? p0(e.slice(4).toLowerCase()) : e;
  });
}, rn = function(u) {
  return d0(u, function(e) {
    return Jr.test(e) ? "xn--" + x0(e) : e;
  });
}, _0 = {
  /**
   * A string representing the current Punycode.js version number.
   * @memberOf punycode
   * @type String
   */
  version: "2.3.1",
  /**
   * An object of methods to convert from JavaScript's internal character
   * representation (UCS-2) to Unicode code points, and back.
   * @see <https://mathiasbynens.be/notes/javascript-encoding>
   * @memberOf punycode
   * @type Object
   */
  ucs2: {
    decode: h0,
    encode: Kr
  },
  decode: p0,
  encode: x0,
  toASCII: rn,
  toUnicode: en
}, nn = {
  options: {
    // Enable HTML tags in source
    html: !1,
    // Use '/' to close single tags (<br />)
    xhtmlOut: !1,
    // Convert '\n' in paragraphs into <br>
    breaks: !1,
    // CSS language prefix for fenced blocks
    langPrefix: "language-",
    // autoconvert URL-like texts to links
    linkify: !1,
    // Enable some language-neutral replacements + quotes beautification
    typographer: !1,
    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Could be either a String or an Array.
    //
    // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
    // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
    quotes: "“”‘’",
    /* “”‘’ */
    // Highlighter function. Should return escaped HTML,
    // or '' if the source string is not changed and should be escaped externaly.
    // If result starts with <pre... internal wrapper is skipped.
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,
    // Internal protection, recursion limit
    maxNesting: 100
  },
  components: {
    core: {},
    block: {},
    inline: {}
  }
}, tn = {
  options: {
    // Enable HTML tags in source
    html: !1,
    // Use '/' to close single tags (<br />)
    xhtmlOut: !1,
    // Convert '\n' in paragraphs into <br>
    breaks: !1,
    // CSS language prefix for fenced blocks
    langPrefix: "language-",
    // autoconvert URL-like texts to links
    linkify: !1,
    // Enable some language-neutral replacements + quotes beautification
    typographer: !1,
    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Could be either a String or an Array.
    //
    // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
    // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
    quotes: "“”‘’",
    /* “”‘’ */
    // Highlighter function. Should return escaped HTML,
    // or '' if the source string is not changed and should be escaped externaly.
    // If result starts with <pre... internal wrapper is skipped.
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,
    // Internal protection, recursion limit
    maxNesting: 20
  },
  components: {
    core: {
      rules: [
        "normalize",
        "block",
        "inline",
        "text_join"
      ]
    },
    block: {
      rules: [
        "paragraph"
      ]
    },
    inline: {
      rules: [
        "text"
      ],
      rules2: [
        "balance_pairs",
        "fragments_join"
      ]
    }
  }
}, cn = {
  options: {
    // Enable HTML tags in source
    html: !0,
    // Use '/' to close single tags (<br />)
    xhtmlOut: !0,
    // Convert '\n' in paragraphs into <br>
    breaks: !1,
    // CSS language prefix for fenced blocks
    langPrefix: "language-",
    // autoconvert URL-like texts to links
    linkify: !1,
    // Enable some language-neutral replacements + quotes beautification
    typographer: !1,
    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Could be either a String or an Array.
    //
    // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
    // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
    quotes: "“”‘’",
    /* “”‘’ */
    // Highlighter function. Should return escaped HTML,
    // or '' if the source string is not changed and should be escaped externaly.
    // If result starts with <pre... internal wrapper is skipped.
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,
    // Internal protection, recursion limit
    maxNesting: 20
  },
  components: {
    core: {
      rules: [
        "normalize",
        "block",
        "inline",
        "text_join"
      ]
    },
    block: {
      rules: [
        "blockquote",
        "code",
        "fence",
        "heading",
        "hr",
        "html_block",
        "lheading",
        "list",
        "reference",
        "paragraph"
      ]
    },
    inline: {
      rules: [
        "autolink",
        "backticks",
        "emphasis",
        "entity",
        "escape",
        "html_inline",
        "image",
        "link",
        "newline",
        "text"
      ],
      rules2: [
        "balance_pairs",
        "emphasis",
        "fragments_join"
      ]
    }
  }
}, on = {
  default: nn,
  zero: tn,
  commonmark: cn
}, an = /^(vbscript|javascript|file|data):/, sn = /^data:image\/(gif|png|jpeg|webp);/;
function fn(u) {
  const e = u.trim().toLowerCase();
  return an.test(e) ? sn.test(e) : !0;
}
const m0 = ["http:", "https:", "mailto:"];
function ln(u) {
  const e = Cu(u, !0);
  if (e.hostname && (!e.protocol || m0.indexOf(e.protocol) >= 0))
    try {
      e.hostname = _0.toASCII(e.hostname);
    } catch {
    }
  return Y(Du(e));
}
function dn(u) {
  const e = Cu(u, !0);
  if (e.hostname && (!e.protocol || m0.indexOf(e.protocol) >= 0))
    try {
      e.hostname = _0.toUnicode(e.hostname);
    } catch {
    }
  return Z(Du(e), Z.defaultChars + "%");
}
function w(u, e) {
  if (!(this instanceof w))
    return new w(u, e);
  e || Fu(u) || (e = u || {}, u = "default"), this.inline = new uu(), this.block = new au(), this.core = new yu(), this.renderer = new V(), this.linkify = new v(), this.validateLink = fn, this.normalizeLink = ln, this.normalizeLinkText = dn, this.utils = he, this.helpers = iu({}, _e), this.options = {}, this.configure(u), e && this.set(e);
}
w.prototype.set = function(u) {
  return iu(this.options, u), this;
};
w.prototype.configure = function(u) {
  const e = this;
  if (Fu(u)) {
    const r = u;
    if (u = on[r], !u)
      throw new Error('Wrong `markdown-it` preset "' + r + '", check name');
  }
  if (!u)
    throw new Error("Wrong `markdown-it` preset, can't be empty");
  return u.options && e.set(u.options), u.components && Object.keys(u.components).forEach(function(r) {
    u.components[r].rules && e[r].ruler.enableOnly(u.components[r].rules), u.components[r].rules2 && e[r].ruler2.enableOnly(u.components[r].rules2);
  }), this;
};
w.prototype.enable = function(u, e) {
  let r = [];
  Array.isArray(u) || (u = [u]), ["core", "block", "inline"].forEach(function(n) {
    r = r.concat(this[n].ruler.enable(u, !0));
  }, this), r = r.concat(this.inline.ruler2.enable(u, !0));
  const c = u.filter(function(n) {
    return r.indexOf(n) < 0;
  });
  if (c.length && !e)
    throw new Error("MarkdownIt. Failed to enable unknown rule(s): " + c);
  return this;
};
w.prototype.disable = function(u, e) {
  let r = [];
  Array.isArray(u) || (u = [u]), ["core", "block", "inline"].forEach(function(n) {
    r = r.concat(this[n].ruler.disable(u, !0));
  }, this), r = r.concat(this.inline.ruler2.disable(u, !0));
  const c = u.filter(function(n) {
    return r.indexOf(n) < 0;
  });
  if (c.length && !e)
    throw new Error("MarkdownIt. Failed to disable unknown rule(s): " + c);
  return this;
};
w.prototype.use = function(u) {
  const e = [this].concat(Array.prototype.slice.call(arguments, 1));
  return u.apply(u, e), this;
};
w.prototype.parse = function(u, e) {
  if (typeof u != "string")
    throw new Error("Input data should be a String");
  const r = new this.core.State(u, this, e);
  return this.core.process(r), r.tokens;
};
w.prototype.render = function(u, e) {
  return e = e || {}, this.renderer.render(this.parse(u, e), this.options, e);
};
w.prototype.parseInline = function(u, e) {
  const r = new this.core.State(u, this, e);
  return r.inlineMode = !0, this.core.process(r), r.tokens;
};
w.prototype.renderInline = function(u, e) {
  return e = e || {}, this.renderer.render(this.parseInline(u, e), this.options, e);
};
const hn = ["innerHTML"], bn = /* @__PURE__ */ C0({
  __name: "VueMarkdownIt",
  props: {
    source: {},
    mdWrapperClass: { default: "vue-md-it-wrapper" },
    plugins: {},
    preset: {},
    options: {}
  },
  setup(u) {
    const e = u, r = e.preset ? new w(e.preset, e.options) : e.options ? new w(e.options) : new w();
    e.plugins && c();
    function c() {
      var t;
      (t = e.plugins) == null || t.forEach((o) => {
        const i = n(o);
        r.use(i[0], i[1]);
      });
    }
    function n(t) {
      return Array.isArray(t) ? t : [t, void 0];
    }
    return (t, o) => (E0(), F0("div", {
      class: A0(t.mdWrapperClass),
      innerHTML: y0(r).render(t.source)
    }, null, 10, hn));
  }
}), xn = {
  install: (u) => {
    u.component("VueMarkdownIt", bn);
  }
};
export {
  bn as VueMarkdownIt,
  xn as VueMarkdownItPlugin
};
